/**
 * Card network types based on BIN (Bank Identification Number) ranges.
 * The first 4-6 digits of a card number identify the issuing network.
 */
export var CardNetwork;
(function (CardNetwork) {
    CardNetwork["VISA"] = "VISA";
    CardNetwork["MASTERCARD"] = "MASTERCARD";
    CardNetwork["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    CardNetwork["MAESTRO"] = "MAESTRO";
    CardNetwork["DISCOVER"] = "DISCOVER";
    CardNetwork["DINERS_CLUB"] = "DINERS_CLUB";
    CardNetwork["JCB"] = "JCB";
    CardNetwork["UNIONPAY"] = "UNIONPAY";
})(CardNetwork || (CardNetwork = {}));
export const BankNames = {
    ['00010']: 'COMITATO DI GESTIONE MTS - MID',
    ['00100']: 'MTS S.P.A.',
    ['01000']: "BANCA D'ITALIA",
    ['01001']: 'UFFICIO ITALIANO DEI CAMBI',
    ['01005']: 'BANCA NAZIONALE DEL LAVORO SPA',
    ['01010']: 'BANCO DI NAPOLI S.P.A.',
    ['01015']: 'BANCO DI SARDEGNA SPA',
    ['01020']: 'BANCO DI SICILIA SPA',
    ['01025']: 'SANPAOLO IMI S.P.A.',
    ['01030']: 'BANCA MONTE DEI PASCHI DI SIENA S.P.A.',
    ['02002']: 'BANCA COMMERCIALE ITALIANA',
    ['02008']: 'UNICREDIT SPA',
    ['03001']: 'BANCO AMBROSIANO VENETO S.P.A.',
    ['03002']: 'UNICREDIT BANCA DI ROMA SPA',
    ['03003']: 'ROYAL BANK OF SCOTLAND PLC',
    ['03004']: 'AMERICAN SERVICE BANK',
    ['03006']: 'EUROPE ARAB BANK PLC',
    ['03008']: 'BANCA AGRARIA',
    ['03009']: 'FCE BANK PLC',
    ['03012']: 'BANCA AGRARIA DI MARSALA',
    ['03015']: 'FINECOBANK SPA',
    ['03017']: 'INVEST BANCA S.P.A.',
    ['03019']: 'CREDITO SICILIANO S.P.A.',
    ['03020']: 'BANCA AGRICOLA NORD CALABRIA',
    ['03021']: 'HSBC CONTINENTAL EUROPE, ITALY',
    ['03024']: 'BANCA AGRICOLA CACCIAGUERRA',
    ['03025']: 'BANCA PROFILO S.P.A.',
    ['03026']: 'BANCA ITALEASE S.P.A.',
    ['03029']: 'MERRILL LYNCH INTERNATIONAL BANK LIMITED',
    ['03030']: 'CREDIOP S.P.A.',
    ['03032']: 'CREDITO EMILIANO SPA',
    ['03034']: 'BANCA AGRICOLA COMMERCIALE DELLA REPUBBLICA DI SAN MARINO',
    ['03036']: 'BANCA AGRICOLA DI CREDITO E RISPARMIO',
    ['03040']: 'CREDIT SUISSE AG',
    ['03041']: 'UBS EUROPE SE SUCCURSALE ITALIA',
    ['03043']: 'BANCA INVESTIS S.P.A.',
    ['03045']: 'BANCA AKROS S.P.A.',
    ['03046']: 'BANCA AMADEO',
    ['03047']: 'BANCA CAPASSO ANTONIO',
    ['03048']: 'BANCA DEL PIEMONTE S.P.A.',
    ['03051']: 'BARCLAYS BANK IRELAND-MILAN BRANCH',
    ['03052']: 'BANCA BELINZAGHI',
    ['03053']: 'BANCAPERTA S.P.A.',
    ['03054']: 'BNP PARIBAS PERSONAL FINANCE SPA',
    ['03055']: 'BAYERISCHE LANDESBANK',
    ['03057']: 'MERRILL LYNCH INTERNATIONAL BANKLTD MILAN BRANCH',
    ['03058']: 'CHE BANCA| S.P.A',
    ['03059']: 'BANCA DI CREDITO SARDO S.P.A.',
    ['03061']: 'CITIBANK INTERNATIONAL PLC',
    ['03062']: 'BANCA MEDIOLANUM S.P.A.',
    ['03064']: 'BANCA SELLA NORD EST-BOVIO CALDERARI SPA',
    ['03067']: 'BANCA CARIME S.P.A.',
    ['03069']: 'INTESA SANPAOLO SPA',
    ['03070']: 'BANCA CARLO BUFFA',
    ['03072']: 'BANCA CARNICA',
    ['03073']: 'BHW BAUSPARKASSE A.G.',
    ['03075']: 'BANCA GENERALI S.P.A.',
    ['03076']: 'BANCA CATTOLICA DEL VENETO',
    ['03077']: 'BANCO AMBROSIANO VENETO SUD SPA',
    ['03078']: "BANCA DELL'ARTIGIANATO E DELL'INDUSTRIA S.P.A.",
    ['03081']: 'BAYERISCHE HYPO - UND VEREINSBANK AG',
    ['03083']: 'IW BANK S.P.A.',
    ['03084']: 'BANCA CESARE PONTI',
    ['03085']: 'CATERPILLAR FINANCIAL CORPORATION F. S. A. E. F. DE CREDITO',
    ['03087']: 'BANCA FINNAT EURAMERICA S.P.A.',
    ['03089']: 'CREDIT SUISSE (ITALY) S.P.A.',
    ['03093']: 'BANK OF CHINA',
    ['03094']: 'BANCO DI BERGAMO',
    ['03095']: 'COMMERZBANK A.G.',
    ['03097']: 'AAREAL BANK AG',
    ['03099']: 'NEOS BANCA SPA.',
    ['03101']: 'BANQUE PSA FINANCE SA',
    ['03102']: 'BANCA ALETTI S.P.A.',
    ['03103']: 'RCI BANQUE S.A.',
    ['03104']: 'DEUTSCHE BANK SPA',
    ['03105']: 'VOLKSWAGEN BANK GMBH',
    ['03108']: 'BANCA DE BIASE & C.',
    ['03109']: 'DIEBOLD COMPUTER LEASING - DCL - S.A.',
    ['03110']: 'BANCA CREDIFARMA S.P.A.',
    ['03111']: 'UNIONE DI BANCHE ITALIANE S.P.A.',
    ['03112']: 'BANCA DEI COMUNI VESUVIANI',
    ['03115']: 'FINDOMESTIC BANCA SPA',
    ['03119']: 'UNIBANCA S.P.A.',
    ['03120']: 'BANCA DEL FRIULI',
    ['03123']: 'AGRILEASING BANCA PER IL LEASING DELLE B.C.C. - C.R.A. S.P.A.',
    ['03124']: 'BANCA DEL FUCINO',
    ['03126']: 'CA INDOSUEZ WEALTH (ITALY) S.P.A.',
    ['03127']: 'UNIPOL BANCA S.P.A',
    ['03131']: 'UNICREDIT BANCA MOBILIARE S.P.A.',
    ['03132']: 'BANCA DEL LAVORO',
    ['03135']: 'UNICREDITO SPA',
    ['03136']: 'BANCA DEL LAVORO E DEL PICCOLO RISPARMIO',
    ['03138']: 'BANCA REALE S.P.A.',
    ['03139']: 'BANCA PER LO SVILUPPO DELLA COOPERAZIONE DI CREDITO S.P.A.',
    ['03140']: 'MPS BANCA PERSONALE SPA',
    ['03141']: 'BANCA DI TREVISO S.P.A.',
    ['03149']: 'BANCO EMILIANO ROMAGNOLO S.P.A.',
    ['03150']: 'DEUTSCHE BANK MUTUI S.P.A.',
    ['03151']: 'HYPO TIROL BANK AG - SUCCURSALE ITALIA',
    ['03158']: 'BANCA SISTEMA S.P.A.',
    ['03159']: 'BANCA CONSULIA SPA',
    ['03162']: 'MORGAN STANLEY DEAN WITTER BANK LIMITED',
    ['03165']: 'IW BANK S.P.A.',
    ['03170']: 'FINANZA & FUTURO BANCA S.P.A.',
    ['03177']: 'BANCASAI S.P.A.',
    ['03179']: 'BNP PARIBAS LEASE GROUP SA',
    ['03181']: 'BNP PARIBAS SUCCURSALE ITALIA',
    ['03183']: 'MEDIOBANCA BANCA DI CREDITO FINANZIARIO SPA',
    ['03185']: 'BANCA IFIGEST S.P.A.',
    ['03186']: 'B@NCA 24-7 S.P.A.',
    ['03189']: 'NATIXIS S.A. - SUCCURSALE DI MILANO',
    ['03191']: 'SANTANDER CONSUMER BANK S.P.A.',
    ['03193']: 'BANCA VALLONE - GALATINA (LECCE)',
    ['03196']: 'BANCA DI GIRGENTI',
    ['03198']: 'UNICREDIT BANCA PER LA CASA SPA',
    ['03204']: 'BANCA DI LEGNANO S.P.A.',
    ['03205']: 'BANCA IFIS S.P.A.',
    ['03207']: 'CAPITALIA S.P.A.',
    ['03208']: 'BANCA DI LUCANIA',
    ['03210']: 'BANCA MPS LEASING & FACTORING',
    ['03211']: 'BANCA PATRIMONI SPA',
    ['03215']: 'FINECOGROUP SPA',
    ['03218']: 'UNICREDIT FAMILY FINANCING',
    ['03219']: 'MPS GESTIONE CREDITI BANCA S.P.A',
    ['03220']: 'BANCA DI MARSALA',
    ['03221']: 'BANCA BNL INVESTIMENTI S.P.A.',
    ['03222']: 'SGB FINANCE ITALIA',
    ['03223']: 'UNICREDIT PRIVATE BANKING S.P.A.',
    ['03224']: 'BANCA DI MESSINA',
    ['03225']: 'BANCA CENTRALE DELLA REPUBBLICA DI SAN MARINO',
    ['03226']: "UNICREDIT BANCA D'IMPRESA S.P.A.",
    ['03227']: 'CNH CAPITAL EUROPE',
    ['03230']: 'DEPFA BANK PLC',
    ['03232']: "BANCA DI PATERNO'",
    ['03233']: 'ISTITUTO BANCARIO SICILIANO MARSALA',
    ['03234']: 'BANCA PIEMONTESE',
    ['03235']: 'BANCA DI SCONTO S.P.A.',
    ['03238']: 'BANCA DI SPILIMBERGO - A. TAMAI & C.',
    ['03239']: 'INTESA SANPAOLO PRIVATE BANKING S.P.A.',
    ['03240']: 'BANCA DI TRENTO E BOLZANO',
    ['03242']: 'BANCO DI LUCCA E DEL TIRRENO SPA',
    ['03244']: 'BANCA DI VALLE CAMONICA S.P.A.',
    ['03245']: 'CREVERBANCA SPA',
    ['03246']: "BANCA DONATO MONGIO'",
    ['03249']: 'BANCA IMI SPA',
    ['03250']: 'CREDEM - EUROMOBILIARE PRIVATE BANKING S.P.A.',
    ['03253']: 'BANCA FEDERICO DEL VECCHIO',
    ['03258']: 'ERSEL S.P.A.',
    ['03262']: 'ASSET BANCA S.P.A.',
    ['03263']: 'IBL BANCA ISTITUTO BANCARIO DEL LAVORO S.P.A.',
    ['03265']: 'BANCA PROMOS S.P.A.',
    ['03266']: 'BANCA FININT S.P.A.',
    ['03267']: 'BANCA GALILEO S.P.A.',
    ['03268']: 'BANCA SELLA SPA',
    ['03269']: 'BANCA DELLA NUOVA TERRA S.P.A.',
    ['03270']: 'BANCA GATTO E PORPORA',
    ['03271']: 'ALLFUNDS BANK S.A.',
    ['03272']: 'BANCA GENERALE DI CREDITO',
    ['03273']: 'SOLUTION BANK S.P.A.',
    ['03275']: 'RETI BANCARIE SPA',
    ['03278']: 'BANCA EMILVENETA S.P.A.',
    ['03280']: 'BANCA INDUSTRIALE AGRICOLA DI RADICENA',
    ['03281']: 'GENERAL ELECTRONIC CAPITAL BANK S.A.',
    ['03282']: 'BANCA INDUSTRIALE DEL LAZIO SPA - CASSINO (FROSINONE)',
    ['03285']: 'MACQUARIE BANK LIMITED',
    ['03287']: 'BANCA SAMMARINESE DI INVESTIMENTO',
    ['03288']: 'BANCA INDUSTRIALE',
    ['03293']: 'BANCA MALDARI',
    ['03296']: 'FIDEURAM - INTESA SANPAOLO PRIVATE BANKING SPA',
    ['03297']: 'BANCA MEDITERRANEA DI CREDITO',
    ['03298']: 'DEUTSCHE BANK AG',
    ['03299']: 'IXS CORPORATE & INVESTIMENT BANK',
    ['03300']: 'CREDITO DEL LAZIO S.P.A.',
    ['03301']: 'CASSA DEI RISPARMI DI MILANO E DELLA LOMBARDIA SPA',
    ['03305']: 'NATEXIS LEASE S.A.',
    ['03306']: 'PRADER BANK SPA',
    ['03307']: "SOCIETE' GENERALE SECURITIES SERVICE",
    ['03309']: 'BANCA INFRASTRUTTURE INNOVAZIONE E SVILUPPO',
    ['03310']: 'ETICREDITO - BANCA ETICA ADRIATICA S.P.A.',
    ['03311']: 'BANCA SELLA HOLDING S.P.A.',
    ['03313']: 'BANCA IMPRESA LAZIO SPA',
    ['03315']: 'DEUTSCHE PFANDBRIEFBANK AG',
    ['03317']: 'BANCA MACERATA S.P.A.',
    ['03321']: 'RBC INVESTOR SERVICE BANK S.A.',
    ['03329']: 'KARNTNER SPARKASSE AG',
    ['03330']: 'BANCA INTERREGIONALE S.P.A.',
    ['03331']: 'CENTRO LEASING BANCA S.P.A.',
    ['03332']: 'BANCA PASSADORE & C.',
    ['03334']: 'TOYOTA KREDITBANK GMBH',
    ['03336']: 'CREDITO BERGAMASCO S.P.A.',
    ['03337']: 'SUMITOMO MITSUI BANKING CORPORATION EUROPE LIMITED',
    ['03338']: 'SERFINA BANCA S.P.A.',
    ['03339']: 'ING REAL ESTATE FINACE (ESPANA) EFC SA SUCC. DI MILANO',
    ['03343']: 'PICTET & CIE (EUROPE) S.A',
    ['03344']: 'BANCA DI BISCEGLIE',
    ['03346']: 'MIZUHO BANK, LTD',
    ['03349']: 'CNH INDUSTRIAL FINANCIAL SERVICES S.A.',
    ['03351']: 'THE BANK OF NEW YORK (LUXEMBOURG) S.A.',
    ['03353']: 'BANCA DEL SUD S.P.A',
    ['03357']: 'BANCA A.G.C.I.',
    ['03358']: 'CLAAS FINANCIAL SERVICES',
    ['03359']: 'BANCA PROSSIMA S.P.A.',
    ['03362']: 'DE LAGE LANDEN INTERNATIONAL B V (DLL)',
    ['03365']: 'CHERRY BANK S.P.A.',
    ['03367']: 'BANCA SANTA GIULIA S.P.A.',
    ['03368']: 'BANCA ROSENBERG COLORNI & CO.',
    ['03370']: 'J.P. MORGAN INTERNATIONAL BANK LIMITED',
    ['03373']: 'KBC BANK N.V.',
    ['03374']: 'SUEDTIROL BANK S.P.A.',
    ['03378']: "SOCIETE' GENERALE MUTUI ITALIA SPA",
    ['03379']: 'BANK OF CREDIT AND COMMERCE INTERNATIONAL S.A. - MILANO',
    ['03380']: 'BANK OF AMERICA MERRILL LYNCH INTERNATIONAL D.A.C.SUCCURSALE MILANO',
    ['03381']: 'BANK SEPAH',
    ['03385']: 'ISYBANK S.P.A.',
    ['03386']: 'JCB FINANCE',
    ['03387']: 'BANQUE CHAABI DU MAROC',
    ['03388']: 'BANCA STABIESE',
    ['03389']: 'BANCO SANTANDER S.A.',
    ['03390']: 'BANCA SUBALPINA',
    ['03392']: 'BANCA TIBURTINA DI CREDITO E SERVIZI - TIVOLI (ROMA)',
    ['03393']: 'BANCA SVILUPPO ECONOMICO S.P.A.',
    ['03394']: 'MAINFIRST BANK AG',
    ['03395']: 'ILLIMITY BANK S.P.A.',
    ['03398']: 'BANCA SIMETICA S.P.A.',
    ['03399']: 'EXTRABANCA S.P.A.',
    ['03400']: 'BANCA TOSCANA S.P.A.',
    ['03401']: 'STANDARD CHARTERED BANK',
    ['03402']: 'WEBANK S.P.A.',
    ['03403']: 'IMPREBANCA SPA',
    ['03407']: 'EDMOND DE ROTSCHILD BANQUE',
    ['03409']: 'BANCA VENTURI',
    ['03411']: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (EUROPE) S.A.',
    ['03413']: 'BANCA ZANONE',
    ['03415']: 'ATTIJARIWAFA BANK EUROPE',
    ['03417']: 'BANCA PRIVATA LEASING S.P.A.',
    ['03419']: 'J.P. MORGAN SECURITIES PLC',
    ['03423']: 'BINCKBANK NV',
    ['03425']: 'BANCO DI CREDITO P.AZZOAGLIO',
    ['03426']: 'BANCA DI CREDITO PELORITANO S.P.A.',
    ['03427']: 'UNION BANCAIRE PRIVEE (LUXENBOURG) SA',
    ['03430']: 'CREDITO LOMBARDO VENETO SPA',
    ['03431']: 'BANCA CARIGE ITALIA SPA',
    ['03432']: 'CREDIT AGRICOLE - CORPORATE AND INVESTMENT BANK',
    ['03434']: 'BMW BANK GMBH',
    ['03435']: 'BANCA FARMAFACTORING SPA',
    ['03437']: 'BANCA TRANSILVANIA S.A.',
    ['03438']: 'CACEIS BANK LUXEMBOURG SA',
    ['03439']: 'STATE STREET BANK INTERNATIONAL GMBH - SUCCURSALE ITALIA',
    ['03440']: 'BANCO DI DESIO E DELLA BRIANZA',
    ['03441']: 'BLU BANCA S.P.A.',
    ['03442']: 'BANCA WIDIBA SPA',
    ['03443']: 'CREDIT AGRICOLE LUXEMBOURG',
    ['03445']: 'CA AUTO BANK S.P.A.',
    ['03446']: 'WESTERN UNION INTERNATIONAL BANKGMBH',
    ['03448']: 'BANCO DI PERUGIA',
    ['03459']: 'BANCO DI TRICESIMO',
    ['03475']: 'ING BANK N.V.',
    ['03479']: 'BNP PARIBAS SA - SUCCURSALE ITALIA',
    ['03482']: 'RABOBANK NEDERLAND - COOPERATIEVE CENTRALE RAIFFEISEN - BOARENLEENBANK - MILANO',
    ['03483']: 'BANQUE FRANCAISE DU COMMERCE EXTERIEUR',
    ['03487']: 'MUFG BANK LTD',
    ['03488']: 'CASSA LOMBARDA',
    ['03491']: 'MIDLAND BANK PLCMILANO',
    ['03493']: "CASSA CENTRALE RAIFFEISEN DELL'ALTO ADIGE - RAIFFEISEN LANDESBANK SUEDTIROL",
    ['03494']: 'JPMORGAN CHASE BANK NATIONAL ASSOCIATION',
    ['03495']: 'CHEMICAL BANK - NEW YORK',
    ['03500']: 'BANCO DI BRESCIA S.P.A.',
    ['03503']: 'CONTINENTAL BANK, NATIONAL ASSOCIATION -MILANO',
    ['03508']: 'CREDITO AGRICOLO E COMMERCIALE FASANESE',
    ['03512']: 'CREDITO ARTIGIANO',
    ['03561']: 'ABC INTERNATIONAL BANK PLC MILANO',
    ['03562']: 'THE HONGKONG AND SHANGAI BANKING CORPORATION - MILANO',
    ['03565']: 'THE FIRST NATIONAL BANK OF CHICAGO',
    ['03566']: 'CITIBANK N.A.',
    ['03571']: 'THE BANK OF NEW YORK',
    ['03573']: 'ISTITUTO BANCARIO ITALIANO',
    ['03574']: 'DEUTSCHE BANK',
    ['03575']: 'LLOYDS BANK PLC - MILANO',
    ['03576']: 'BANCO BILBAO VIZCAYA ARGENTARIA S.A.',
    ['03577']: 'THE FIRST NATIONAL BANK OF BOSTON - MILANO',
    ['03583']: 'BANQUE WORMS',
    ['03589']: 'ALLIANZ BANK FINANCIAL ADVISORS SPA',
    ['03592']: "ITABANCA SOCIETA' ITALIANA DI CREDITO",
    ['03593']: "SOCIETE' GENERALE",
    ['03594']: 'STANDARD CHARTERED BANK - MILANO',
    ['03596']: 'BANCA DI ALESSANDRIA',
    ['03597']: 'WELLS FARGO BANK N.A.',
    ['03598']: 'BANCA UBAE S.P.A.',
    ['03599']: 'CASSA CENTRALE BANCA - CREDITO COOPERATIVO ITALIANO S.P.A.',
    ['03610']: 'SCANDINAVIAN BANK LIMITED',
    ['03620']: 'CHINA CONSTRUCTION BANK (EUROPE)S.A.',
    ['03623']: 'BANK OF COMMUNICATIONS (LUXEMBOURG) S.A.',
    ['03625']: 'AIDEXA S.P.A.',
    ['03628']: 'BANCA PSA ITALIA SPA',
    ['03638']: 'YOUNITED',
    ['03641']: 'HEWLETT PACKARD INTERNATIONAL BANK PLC',
    ['03645']: 'LOMBARD ODIER (EUORPE) S.A.',
    ['03646']: 'N26 BANK GMBH',
    ['03647']: 'BUNQ B.V.',
    ['03654']: 'TOYOTA MATERIAL HANDLING COMMERCIAL FINANCE AB',
    ['03655']: 'GRENKE BANK AG',
    ['03656']: 'GUBER BANCA S.P.A.',
    ['03658']: 'GOLDMAN SACHS BANK EUROPE SE',
    ['03660']: 'PERSIA INTERNATIONAL BANK',
    ['03661']: 'MGF',
    ['03662']: 'AK NORDIK AB',
    ['03664']: 'HYUNDAI CAPITAL BANK EUROPE GMBH',
    ['03665']: 'SOLARISBANK AG',
    ['03666']: 'CREDIT SUISSE BANK (EUROPE) S.A.',
    ['03667']: 'ZURICH ITALY BANK SPA',
    ['03668']: 'CAIXABANK, S.A.',
    ['03669']: 'REVOLUT BANK UAB',
    ['03671']: 'COFIDIS SA',
    ['04055']: 'BANCA CAPASSO ANTONIO DI CORRADO E LUIGIA CAPASSO',
    ['04180']: 'BANCA LEUZZI & MEGHA',
    ['05000']: 'BFF BANK S.P.A.',
    ['05004']: 'BANCA AGRARIA COMMERCIALE COOPERATIVA',
    ['05010']: 'CREDITO PIEMONTESE',
    ['05013']: 'BANCA VALORI S.P.A.',
    ['05015']: 'BANCA PROGETTO S.P.A',
    ['05016']: 'BANCA AGRICOLA POPOLARE DI MATINO E LECCE',
    ['05018']: 'BANCA POPOLARE ETICA',
    ['05020']: 'BANCA AGRICOLA INDUSTRIALE DI SULMONA',
    ['05023']: 'BANCA REGIONALE DI SVILUPPO SPA',
    ['05024']: 'BANCA AGRICOLA MANTOVANA S.P.A.',
    ['05025']: 'BANCA FARNESE S.P.A.',
    ['05026']: 'BANCHE POPOLARI UNITE S.C.P.A.',
    ['05029']: 'IGEA DIGITAL BANK S.P.A.',
    ['05030']: 'VIVIBANCA S.P.A',
    ['05033']: 'BANCA POPOLARE DELLE PROVINCIE MOLISANE S.C.P.A.R.L.',
    ['05034']: 'BANCO BPM S.P.A.',
    ['05035']: 'VENETO BANCA S.P.A.',
    ['05036']: 'BANCA AGRICOLA POPOLARE DI RAGUSA S.C.P.A.',
    ['05037']: "BANCA POPOLARE DELLE PROVINCE CALABRE SOCIETA' COOPERATIVA PER AZIONI",
    ['05038']: 'BANCA POPOLARE DEL MEDITERRANEO',
    ['05040']: 'BANCA ANTONVENETA',
    ['05048']: 'BANCA POPOLARE COMMERCIO E INDUSTRIA',
    ['05060']: 'BANCA CATTOLICA S.P.A.',
    ['05068']: 'BANCA COOPERATIVA DEGLI IMPIEGATI DEL BANCO DI SICILIA',
    ['05072']: 'BANCA COOPERATIVA DI BOLOGNA',
    ['05074']: 'BANCA COOPERATIVA DI CAPRAIA MONTELUPO E VITOLINI',
    ['05080']: 'BANCA DI IMOLA SPA',
    ['05088']: 'BANCA POPOLARE DI SAN BENEDETTO DEL TRONTO',
    ['05096']: "BANCA COOPERATIVA NICOLO' MONFORTE",
    ['05100']: 'BANCA COOPERATIVA OPERAIA',
    ['05104']: 'BANCA POPOLARE DEL LAZIO SOC. COOP. PER AZIONI',
    ['05108']: 'BANCA POPOLARE DI TARCENTO',
    ['05116']: 'BANCA VALSABBINA S.C.P.A.',
    ['05132']: 'BANCA NUOVA S.P.A.',
    ['05142']: 'BANCA DI CREDITO POPOLARE - TORRE DEL GRECO',
    ['05156']: 'BANCA DI PIACENZA SOC. COOP. PER AZIONI',
    ['05168']: "BANCA POPOLARE DI PALAZZOLO SULL'OGLIO",
    ['05196']: 'BANCA OPERAIA',
    ['05204']: 'BANCA POPOLARE DI MANTOVA S.P.A.',
    ['05208']: 'BANCA OPERAIA DI BOLOGNA',
    ['05216']: 'CREDITO VALTELLINESE',
    ['05232']: 'BANCA POPOLARE DI LAJATICO',
    ['05236']: 'BANCA POPOLARE DI LONIGO',
    ['05240']: 'BANCA POPOLARE AGRICOLA DI POGGIO RUSCO',
    ['05256']: 'BANCA POPOLARE DEL MEZZOGIORNO S.P.A.',
    ['05262']: 'BANCA POPOLARE PUGLIESE',
    ['05280']: 'BANCA POPOLARE COOPERATIVA DI BAGNACAVALLO E FUSIGNANO',
    ['05296']: 'BANCA POPOLARE DI FONDI',
    ['05297']: 'BANCA POPOLARE DEL FRUSINATE - FROSINONE',
    ['05304']: 'BANCA POPOLARE DI GUALDO TADINO',
    ['05308']: 'BANCA POPOLARE DI ANCONA S.P.A.',
    ['05336']: 'BANCA POPOLARE FRIULADRIA S.P.A.',
    ['05348']: 'BANCA POPOLARE COOPERATIVA DI SCILLA',
    ['05356']: 'BANCA POPOLARE COOPERATIVA FRA I COMMERCIANTI DI AVERSA',
    ['05368']: 'BANCA POPOLARE DEI SETTE COMUNI',
    ['05372']: 'BANCA POPOLARE DEL CASSINATE',
    ['05380']: "BANCA POPOLARE DELL'AGRICOLTURA",
    ['05381']: "BANCA POPOLARE DELL'ALTO LAZIO",
    ['05385']: 'BANCA POPOLARE DI PUGLIA E BASILICATA',
    ['05387']: 'BPER BANCA S.P.A.',
    ['05390']: 'BANCA TIRRENICA SPA',
    ['05392']: 'BANCA DELLA CAMPANIA S.P.A.',
    ['05402']: 'BANCA POPOLARE DEL RISPARMIO E DEL LAVORO',
    ['05412']: 'BANCA POPOLARE DI APRICENA',
    ['05414']: 'BANCA POPOLARE DI APRILIA S.P.A.',
    ['05416']: 'BANCA POPOLARE DI ARZIGNANO',
    ['05424']: 'BANCA POPOLARE DI BARI',
    ['05428']: 'BANCA POPOLARE DI BERGAMO S.P.A.',
    ['05432']: 'BANCA POPOLARE DI BOLOGNA E FERRARA',
    ['05437']: 'BIPOP CARIRE',
    ['05442']: 'BANCA POPOLARE DI BRINDISI',
    ['05444']: 'BANCA POPOLARE DI CAGLI',
    ['05456']: 'BANCA POPOLARE DI CASTEL DI SANGRO',
    ['05464']: 'BANCA POPOLARE DI CASTIGLIONE DELLE STIVIERE',
    ['05468']: 'BANCA POPOLARE DI CAVEZZO',
    ['05472']: 'BANCA POPOLARE DI CEGLIE MESSAPICO',
    ['05476']: 'BANCA POPOLARE DI CESENA',
    ['05484']: 'BANCA DI CIVIDALE S.P.A.',
    ['05492']: 'BANCA POPOLARE DI CODROIPO',
    ['05496']: 'BANCA POPOLARE DI CORTONA',
    ['05500']: 'BANCA POPOLARE DI CREDITO',
    ['05516']: 'BANCA POPOLARE DI DEPOSITI E PRESTITI - S. PIETRO VERNOTICO',
    ['05526']: 'BANCO DI SAN GIORGIO SPA',
    ['05550']: 'BANCA POPOLARE DI LANCIANO E SULMONA S.P.A.',
    ['05560']: 'BANCA POPOLARE DI LUMEZZANE',
    ['05564']: 'BANCA POPOLARE DEL MONTEFELTRO E DEL METAURO',
    ['05572']: 'BANCA POPOLARE DI MAROSTICA',
    ['05576']: 'BANCA POPOLARE DI MARSALA',
    ['05584']: 'BANCA POPOLARE DI MILANO S.P.A.',
    ['05588']: 'BANCA POPOLARE DI MODENA',
    ['05598']: 'BANCA POPOLARE MUSSOMELI',
    ['05602']: 'BANCA POPOLARE COMMERCIALE SPA',
    ['05604']: 'BANCA POPOLARE DI NICASTRO',
    ['05620']: 'BANCA POPOLARE DI PALERMO',
    ['05630']: 'BANCA NETWORK INVESTIMENTI SPA',
    ['05640']: 'BANCA POPOLARE DI RAVENNA SPA',
    ['05644']: 'BANCA POPOLARE DI REGGIO CALABRIA',
    ['05652']: 'SANFELICE 1893 BANCA POPOLARE',
    ['05676']: 'BIBANCA S.P.A.',
    ['05692']: 'BANCA POPOLARE DI SONCINO',
    ['05696']: 'BANCA POPOLARE DI SONDRIO',
    ['05704']: 'BANCA POPOLARE DI SPOLETO SPA',
    ['05708']: "BANCA POPOLARE DI TERAMO E CITTA' SANT'ANGELO",
    ['05716']: 'BANCA POPOLARE DI THIENE',
    ['05724']: 'BANCA POPOLARE DI VALDAGNO',
    ['05728']: 'BANCA POPOLARE DI VICENZA S.P.A.',
    ['05732']: 'BANCA POPOLARE DI VIGEVANO',
    ['05733']: 'BANCA POPOLARE DON BOSCO',
    ['05748']: "BANCA DELL'ADRIATICO S.P.A.",
    ['05768']: 'BANCA POPOLARE DI CATANIA',
    ['05772']: "BANCA POPOLARE SANT'ANGELO SCPA",
    ['05774']: 'BANCA POPOLARE S.EGIDIO DI PERUGIA',
    ['05775']: 'BANCA POPOLARE S.ISIDORO DI CARRUBBA DI GIARRE',
    ['05780']: 'BANCA POPOLARE SANTO STEFANO',
    ['05787']: 'BANCAPULIA SPA',
    ['05788']: 'BANCA POPOLARE SICILIANA',
    ['05792']: 'BANCA POPOLARE VALCONCA',
    ['05796']: 'BANCA SANTI NABORRI E FELICE',
    ['05800']: 'BANCA DI CREDITO POPOLARE DI ROMA',
    ['05804']: 'BANCA POPOLARE DI PONTE VALLECEPPI (PERUGIA)',
    ['05805']: 'BANCA POPOLARE DELLA PESCA',
    ['05824']: "CASSA DI SOVVENZIONI E RISPARMIO FRA IL PERSONALE DELLA BANCA D'ITALIA",
    ['05836']: 'BANCA POPOLARE DEPOSITI E PRESTITI - LECCO',
    ['05848']: 'BANCA POPOLARE S. MARIA ASSUNTA DI CASTELGRANDE - CASTELGRANDE (POTENZA)',
    ['05856']: "BANCA POPOLARE DELL'ALTO ADIGE S.P.A.",
    ['06010']: "CASSA DEI RISPARMI DI FORLI' E DELLA ROMAGNA S.P.A.",
    ['06025']: 'CASSA DI RISPARMIO DI ANCONA',
    ['06030']: 'CASSA DI RISPARMIO DELLA SPEZIA SPA',
    ['06040']: "CARISPAQ - CASSA DI RISPARMIO DELLA PROVINCIA DELL'AQUILA SPA",
    ['06045']: 'CASSA DI RISPARMIO DI BOLZANO SPA',
    ['06050']: 'BANCA TEATINA SPA',
    ['06055']: 'BANCA ADRIATICA S.P.A.',
    ['06060']: 'TERCAS - CASSA DI RISPARMIO DELLA PROVINCIA DI TERAMO SPA',
    ['06065']: 'CASSA DI RISPARMIO DELLA PROVINCIA DI VITERBO S.P.A.',
    ['06067']: 'CASSA DI RISPARMIO DELLA REPUBBLICA DI SAN MARINO',
    ['06070']: 'CARIPLO S.P.A.',
    ['06080']: 'CASSA DI RISPARMIO DI ASCOLI PICENO SPA',
    ['06085']: 'CASSA DI RISPARMIO DI ASTI SPA',
    ['06090']: 'BIVERBANCA S.P.A.',
    ['06095']: 'CASSA DI RISPARMIO DI BRA SPA',
    ['06105']: 'CASSA RISPARMIO CARPI S.P.A.',
    ['06110']: 'CASSA DI RISPARMIO DI CARRARA SPA',
    ['06115']: 'CASSA DI RISPARMIO DI CENTO S.P.A.',
    ['06120']: 'CASSA DI RISPARMIO DI CESENA SPA',
    ['06125']: "CASSA DI RISPARMIO DI CITTA' DI CASTELLO SPA",
    ['06130']: 'CASSA DI RISPARMIO DI CIVITAVECCHIA SPA',
    ['06145']: 'CASSA DI RISPARMIO DI FANO SPA',
    ['06150']: 'CASSA DI RISPARMIO DI FERMO SPA',
    ['06155']: 'NUOVA CASSA DI RISPARMIO DI FERRARA S.P.A.',
    ['06160']: 'CASSA DI RISPARMIO DI FIRENZE SPA',
    ['06165']: 'CASSA DI RISPARMIO DI FOLIGNO SPA',
    ['06170']: 'CASSA DI RISPARMIO DI FOSSANO SPA',
    ['06175']: 'BANCA CARIGE S.P.A. - CASSA DI RISPARMIO DI GENOVA E IMPERIA',
    ['06195']: 'CARILO - CASSA DI RISPARMIO DI LORETO SPA',
    ['06205']: 'BANCA DI ROMAGNA S.P.A.',
    ['06210']: 'CASSA DI RISPARMIO DI MODENA',
    ['06215']: 'CASSA DI RISPARMIO DI NARNI',
    ['06220']: 'CASSA DI RISPARMIO DI ORVIETO SPA',
    ['06225']: 'CASSA DI RISPARMIO DEL VENETO',
    ['06230']: 'CREDIT AGRICOLE ITALIA',
    ['06235']: "BANCA DELL'UMBRIA 1462 S.P.A.",
    ['06245']: 'BANCA CARIPE S.P.A.',
    ['06260']: 'CASSA DI RISPARMIO DI PISTOIA E DELLA LUCCHESIA',
    ['06270']: 'LA CASSA DI RAVENNA S.P.A.',
    ['06280']: 'CASSA DI RISPARMIO DI RIETI SPA',
    ['06285']: 'CASSA DI RISPARMIO DI RIMINI SPA',
    ['06290']: 'CASSA DI RISPARMIO DI ROMA',
    ['06295']: 'CASSA DI RISPARMIO DI SALUZZO SPA',
    ['06300']: 'CASSA DI RISPARMIO DI SAN MINIATO SPA',
    ['06305']: 'BANCA CASSA DI RISPARMIO DI SAVIGLIANO SPA',
    ['06310']: 'CASSA DI RISPARMIO DI SAVONA SPA',
    ['06315']: "CASSE DI RISPARMIO DELL'UMBRIA",
    ['06340']: 'CASSA DI RISPARMIO DEL FRIULI VENEZIA GIULIA S.P.A.',
    ['06345']: 'CASSA DI RISPARMIO DI VENEZIA SPA',
    ['06360']: 'CASSA DI RISPARMIO DI VIGEVANO',
    ['06370']: 'CASSA DI RISPARMIO DI VOLTERRA SPA',
    ['06380']: 'CASSA DI RISPARMIO DI TERNI E NARNI SPA',
    ['06385']: 'CASSA DI RISPARMIO IN BOLOGNA SPA',
    ['06387']: 'CASSA DI RISPARMIO MOLISANA - MONTE ORSINI',
    ['06390']: 'INTESA GESTIONE CREDITI S.P.A.',
    ['06905']: 'BANCA DEL MONTE DI BOLOGNA E RAVENNA',
    ['06906']: 'BANCA REGIONALE EUROPEA SPA',
    ['06915']: 'BANCA DEL MONTE DI LUCCA SPA',
    ['06925']: 'BANCA DEL MONTE DI MILANO - MONTE DI CREDITO SU PEGNO',
    ['06930']: 'BANCA MONTE PARMA SPA',
    ['06935']: 'BANCA DEL MONTE DI PAVIA E BERGAMO',
    ['07010']: 'BANCA DI CREDITO COOPERATIVO DI MAIERATO',
    ['07012']: 'BANCA DI BARI E TARANTO CREDITO COOPERATIVO - SOC. COOP.',
    ['07017']: 'BANCA DI CREDITO COOPERATIVO DELCIRCEO E PRIVERNATE',
    ['07026']: 'BANCA DI TERAMO DI CREDITO COOPERATIVO SOC. COOP.',
    ['07027']: 'BANCA DI CREDITO COOPERATIVO DI MONOPOLI S.C.R.L.P.A.',
    ['07048']: "BANCA DELL'ELBA CREDITO COOPERATIVO S.C.",
    ['07056']: "BANCA DI CREDITO COOPERATIVO DELL'ALTA MURGIA S.C.P.A.R.L.",
    ['07058']: 'BANCA REGGIANA - CREDITO COOPERATIVO - S.C.R.L.',
    ['07060']: 'BANCA DI CREDITO COOPERATIVO DEL GARIGLIANO - S.C.R.L.',
    ['07062']: 'CREDITO COOPERATIVO MEDIOCRATI SOC. COOP. A R.L.',
    ['07066']: 'BANCA DI CREDITO COOPERATIVO DI BUCCINO E DEI COMUNI CILENTANI S.C.',
    ['07067']: 'BANCA DELLA TUSCIA CREDITO COOP ERATIVO S.C.R.L.',
    ['07070']: 'CREDITO COOPERATIVO ROMAGNOLO - BCC DI CESENA E GATTEO SOC. COOP.',
    ['07072']: "EMIL BANCA - CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['07074']: 'BANCA DI MONASTIER E DEL SILE CREDITO COOPERATIVO S.C.R.L.',
    ['07075']: 'BANCA CENTRO - CREDITO COOPERATIVO TOSCANA-UMBRIA SOC. COOP.',
    ['07076']: 'BANCA CREMASCA E MANTOVANA CRED.COOP. SOC. COOP.',
    ['07078']: 'BANCA DI CREDITO COOPERATIVO DEI CASTELLI E DEGLI IBLEI S.C.R.L.',
    ['07080']: 'CREDITO ETNEO - BANCA DI CREDITOCOOPERATIVO S.C.R.L.',
    ['07083']: 'BANCA DI CREDITO COOPERATIVO PRIVERNATE S.C.P.A.R.L.',
    ['07084']: "BANCA DELLA MARCA CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['07085']: 'CREDITO COOPERATIVO FRIULI SCRL',
    ['07086']: "BANCA DI CREDITO COOPERATIVO DELL'ADRIATICO TERAMANO S.C.R.L.",
    ['07087']: 'BANCA DI TARANTO E MASSAFRA BANCA DI CREDITO COOPERATIVO - SC',
    ['07090']: 'BANCA MALATESTIANA - CREDITO COOPERATIVO S.C.',
    ['07091']: 'BANCA DI CREDITO COOPERATIVO DELLA CALABRIA ULTERIORE',
    ['07092']: 'BANCA DI CREDITO COOPERATIVO DEI CASTELLI ROMANI E DEL TUSCOLO',
    ['07094']: 'BANCA DI CREDITO COOPERATIVO DI MASSAFRA',
    ['07095']: 'BANCA APUANA - CREDITO COOPERATIVO DI MASSA CARRARA S.C.A.R.L.',
    ['07096']: 'BANCA DI CREDITO COOPERATIVO DI CAGLIARI',
    ['07099']: 'CREDITO ARETUSEO BANCA DI CREDITO COOPERATIVO SOC. COOP.A.R.L',
    ['07100']: 'BANCA DI CREDITO COOPERATIVO DELLA CONTEA DI MODICA SOC. COOP',
    ['07101']: 'BANCA DI ANDRIA DI CREDITO COOP.S.C.A.R.L.',
    ['07107']: 'BANCA DEL FERMANO - CREDITO COOPERATIVO -',
    ['07108']: 'BANCA DI CREDITO COOPERATIVO AGRIGENTINO',
    ['07110']: "BANCA DI CREDITO COOPERATIVO DI NAPOLI SOCIETA' COOPERATIVA PER AZIONI",
    ['07111']: "BANCA DI FRASCATI DI CREDITO COOPERATIVO SOCIETA' COOPERATIVA PER AZIONI",
    ['07112']: 'BANCA DI VIGEVANO - CREDITO COOPERATIVO',
    ['07113']: 'BANCA DI CREDITO COOPERATIVO DI PUTIGNANO S.C.P.A.',
    ['07115']: 'CREDITO COOPERATIVO DI SCANDICCI - BANCO FIORENTINO -',
    ['07116']: "BANCA DEL GRAN SASSO D'ITALIA - BANCA DI CREDITO COOPERATIVO SCPA",
    ['07117']: 'BCC DI RIVAROLO CANAVESE, RIVARAED ENTI TERRITORIALI LOCALI - SC',
    ['07118']: "BANCA DI PARMA - CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['07510']: 'BANCA DEL MONTE DI MONTAGNANA - MONTE DI CREDITO SU PEGNO DI MONTAGNANA',
    ['07601']: 'POSTE ITALIANE SPA',
    ['07602']: 'CASSA DEPOSITI E PRESTITI',
    ['07800']: 'CENTRO TECNICO PER LA RETE UNITARIA DELLA PUBBLICA AMMINISTRAZIONE',
    ['08000']: 'ICCREA BANCA S.P.A. - ISTITUTO CENTRALE DEL CREDITO COOPERATIVO',
    ['08003']: 'VIVAL BANCA - BCC DI MONTECATINITERME, BIENTINA E S. PIETRO IN VINCIO S.C.',
    ['08004']: 'CASSA RURALE ED ARTIGIANA DI TERRENOVE DI MARSALA (TRAPANI)',
    ['08009']: 'CASSA RURALE DI PIEVE DI SANZENO - SANZENO (TRENTO)',
    ['08010']: 'CASSA RAIFFEISEN VAL BADIA SCRL',
    ['08011']: 'CASSA RURALE VALLAGARINA -B.C.C . S.C.',
    ['08013']: 'CASSA RURALE DI ALDENO E CADINE B.C.C. S.C.P.A.R.L.',
    ['08016']: 'CASSA RURALE ALTOGARDA - ROVERETO',
    ['08018']: 'CASSA RURALE ED ARTIGIANA DI SAVIGNANO IRPINO (AV) - SCALO DI SAVIGNANO IRPINO',
    ['08019']: 'BANCA DELLO JONIO - CREDITO COOPERATIVO - ALBIDONA',
    ['08020']: 'CASSA RAIFFEISEN ALTA PUSTERIA S.A.R.L.',
    ['08024']: 'CASSA RURALE ADAMELLO BCC',
    ['08026']: 'CASSA RURALE DI LEDRO BANCA DI CREDITO COOPERATIVO S.C.P.A. A R.L.',
    ['08027']: 'CASSA RURALE DI BLEGGIO INFERIORE',
    ['08028']: 'CASSA RURALE DI BONDO BREGUZZO',
    ['08030']: 'BANCA DI CREDITO COOPERATIVO DI BORGHETTO LODIGIANO S.C.R.L.',
    ['08031']: 'CASSA RURALE DI BRENTONICO BANCADI CREDITO COOPERATIVO SCPARL',
    ['08035']: 'CASSA RAIFFEISEN DI BRUNICO SCRLRAIFFEISENKASSE BRUNECK GEN.M.B.H.',
    ['08039']: 'BANCA DI CREDITO COOPERATIVO DI SASSANO S.C.R.L.',
    ['08042']: 'CASSA RURALE DI RABBI E CALDES SCRL BCC',
    ['08043']: 'CASSA RURALE DI CALDONAZZO',
    ['08048']: 'CASSA RURALE DI CAORIA',
    ['08049']: 'CASSA RURALE DI CAPRIANA',
    ['08050']: 'CASSA RURALE DI CARANO',
    ['08052']: "CASSA RURALE DI CASTAGNE'",
    ['08054']: 'CASSA RURALE DI CASTELLO DI FIEMME',
    ['08056']: 'CASSA RAIFFEISEN CASTELROTTO - ORTISEI SOC. COOP.',
    ['08060']: 'CASSA RAIFFEISEN DI CIARDES S.C.',
    ['08061']: 'CASSA RURALE DI CLOZ',
    ['08065']: "CASSA RAIFFEISEN SCHLERN-ROSENGARTEN SOCIETA' COOPERATIVA",
    ['08066']: 'CASSA RAIFFEISEN ALTA VENOSTA SOC. COOP.',
    ['08070']: 'CASSA RURALE ED ARTIGIANA DI S. MARCO ARGENTANO (COSENZA)',
    ['08071']: 'BANCA DI CREDITO COOPERATIVO DI VALLEDOLMO',
    ['08076']: 'CASSA RURALE ED ARTIGIANA DI CEPPALONI (BENEVENTO)',
    ['08077']: 'CASSA RURALE DI DAMBEL',
    ['08078']: 'LA CASSA RURALE - CC ADAMELLO GIUDICARIE VALSABBIA PAGANELLA - SC',
    ['08079']: 'CASSA RURALE BASSA ANAUNIA',
    ['08080']: 'CASSA RAIFFEISEN DI DOBBIACO SCRL-RAIFFEISENKASSE TOBLACH GMBH',
    ['08081']: 'CASSA RURALE DI BOLZANO - RAIFFEISENKASSE BOZEN',
    ['08083']: 'CASSA RURALE ED ARTIGIANA DI FISCIANO (SALERNO)',
    ['08084']: 'CASSA RURALE ED ARTIGIANA DI TREBASELEGHE',
    ['08086']: 'BANCA DI ANCONA E FALCONARA MARITTIMA CREDITO COOPERATIVO S.C.',
    ['08088']: "CASSA RURALE DON LORENZO GUETTI DI QUADRA-FIAVE'- B.C.C.",
    ['08091']: 'CASSA RURALE DEGLI ALTIPIANI BANCA DI CREDITO COOPERATIVO',
    ['08094']: 'CASSA RAIFFEISEN DI FUNES SC RAIFFEISENKASSE VILLNOSS G.M.B.H.',
    ['08095']: "CREDITO COOPERATIVO REGGIANO SOCIETA' COOPERATIVA",
    ['08098']: 'CASSA RURALE ED ARTIGIANA DI CETO - BS',
    ['08100']: 'CASSA RURALE DI GIOVO BCC',
    ['08102']: "CASSA RURALE VALSUGANA E TESINO BCC - SOCIETA' COOPERATIVA",
    ['08106']: 'CASSA RURALE DI IMER',
    ['08107']: "CASSA RURALE DI ISERA BANCA DI CREDITO COOPERATIVO SOCIETA' COOPERATIVA",
    ['08110']: 'CASSA RAIFFEISEN DI LACES SCRL RAIFFEISENKASSE LATSCH G.M.B.H.',
    ['08112']: 'CASSA RAIFFEISEN DI LAGUNDO SCRL',
    ['08113']: "CASSA RAIFFEISEN BASSA VALL'ISARCO SOCIETA' COOPERATIVA",
    ['08114']: 'CASSA RAIFFEISEN BASSA ATESINA S.C.',
    ['08115']: 'CASSA RAIFFEISEN DI LANA S.C. RAIFFEISENKASSE LANA GEN.D.OB.',
    ['08116']: 'CASSA RURALE DI LANZA-MOCENIGO',
    ['08117']: 'CASSA RAIFFEISEN DI LASA S.C. RAIFFEISENKASSE LAAS GEN.M.B.H.',
    ['08120']: 'CASSA RURALE LAVIS - MEZZOCORONA - VALLE DI CEMBRA BCC - S.C.',
    ['08121']: 'CASSA RURALE DI LEVICO TERME',
    ['08123']: 'CASSA RURALE DI LIZZANA BANCA DI CREDITO COOPERATIVO S.C.P.A.R.L.',
    ['08126']: 'BANCA MONTEPAONE CREDITO COOPERATIVO - SOC. COOP.',
    ['08127']: 'CASSA RURALE ED ARTIGIANA DI MASERADA SUL PIAVE',
    ['08132']: 'CASSA RURALE DELLA VALLE DEI LAGHI',
    ['08133']: 'CASSA RAIFFEISEN MERANO SOC. COOP. A R.L.',
    ['08134']: 'CASSA RAIFFEISEN DI MARLENGO SOC. COOP.',
    ['08136']: 'CASSA RURALE DI MEZZANA',
    ['08138']: 'CASSA RURALE DI MEZZOCORONA B.C.C. S.C.P.A.R.L.',
    ['08139']: 'CASSA RURALE ROTALIANA E GIOVO BANCA DI CREDITO COOPERATIVO',
    ['08140']: 'FPB CASSA DI FASSA PRIMIERO BELLUNO-BANCA DI CRED. COOP.-SOC. COOP.',
    ['08144']: 'CASSA RURALE DI MONTAGNE',
    ['08145']: 'CASSA RURALE MORI - BRENTONICO - VAL DI GRESTA - BCC SC',
    ['08148']: 'CASSA RUR.MONGUELFO-CASIES-TESIDO-RAIFFEISENKASSE WELSBERG-GSIES-TAISTEN',
    ['08149']: 'BANCA DI CREDITO COOPERATIVO DI BASCIANO',
    ['08154']: 'BANCA 2021-CRED.COOP. DEL CILENTO, VALLO DI DIANO E LUCANIA S.C.',
    ['08156']: 'CASSA RURALE DI NANNO',
    ['08157']: 'CASSA RAIFFEISEN BASSA VENOSTA SC',
    ['08159']: "CASSA RURALE DI NOGARE'",
    ['08162']: 'CASSA RAIFFEISEN DI NOVA PONENTE-ALDINO SOC. COOP. A R.L.',
    ['08163']: 'CASSA RURALE VAL DI SOLE',
    ['08169']: 'CASSA RURALE DI OSPEDALETTO',
    ['08170']: 'CASSA RURALE DI OSSANA',
    ['08175']: 'CASSA RAIFFEISEN DI PARCINES S.C.',
    ['08177']: 'CASSA RURALE DI PELLIZZANO',
    ['08178']: 'CASSA RURALE ALTA VALSUGANA BANCA DI CREDITO COOPERATIVO - SOC. COOP.',
    ['08179']: 'CASSA RURALE DI PINZOLO',
    ['08182']: 'CASSA RAIFFEISEN WIPPTAL SCRL',
    ['08183']: 'CASSA RAIFFEISEN PRATO-TUBRE SOC.COOP',
    ['08184']: 'CASSA RURALE VAL DI FIEMME BANCA DI CREDITO COOPERATIVO',
    ['08186']: 'BANCA ATESTINA DI CREDITO COOPERATIVO S.C.',
    ['08187']: 'CASSA RURALE RENON SOC. COOP. RAIFFEISENKASSE RITTEN GEN.',
    ['08188']: 'CASSA RURALE ED ARTIGIANA SAN CARLO - TOMMASO NATALE (PA)',
    ['08189']: 'BANCA DI CREDITO COOPERATIVO DELLA VALLE DEL TRIGNO',
    ['08190']: 'CASSA RURALE ED ARTIGIANA MARIA SS. DEL ROSARIO - MASCALI (CT)',
    ['08193']: 'CASSA RURALE ED ARTIGIANA DI STORNARELLA - STORNARELLA (FOGGIA)',
    ['08195']: 'CASSA RURALE ED ARTIGIANA DI SAN QUIRINO(PORDENONE)',
    ['08196']: 'CASSA RURALE DI RABBI',
    ['08198']: 'CASSA RURALE DI RAOSSI VALLARSA',
    ['08200']: 'CASSA RURALE NOVELLA E ALTA ANAUNIA B.C.C. SOC. COOP.',
    ['08204']: 'CASSA RURALE DI ROMALLO',
    ['08207']: 'CASSA RURALE DI RONCO',
    ['08208']: 'CASSA RURALE DI RONCONE',
    ['08209']: "CASSA RURALE DI ROVERE' DELLA LUNA",
    ['08210']: 'CASSA RURALE DI ROVERETO - BANCA DI CREDITO COOPERATIVO SOC. COOP.',
    ['08211']: 'CASSA RURALE DI RUMO',
    ['08214']: 'CREDICOOP CERNUSCO SUL NAVIGLIO SC',
    ['08220']: 'CASSA RURALE DI SALORNO - RAIFFEISENKASSE SALURN',
    ['08223']: 'CASSA RURALE DI SAN LORENZO E ANDALO',
    ['08226']: 'CASSA RAIFFEISEN DI SAN MARTINO IN PASSIRIA S.C.',
    ['08230']: 'CASSA RURALE DI S.ANNA E RIVA DI VALLARSA',
    ['08231']: 'CASSA RURALE DI ULTIMO - S. PANCRAZIO - LAUREGNO S.C.',
    ['08232']: 'CASSA RURALE DI SAONE - BANCA DI CREDITO COOPERATIVO S.C.P.A.R.L.',
    ['08233']: 'CASSA RAIFFEISEN VAL SARENTINO S.C.',
    ['08234']: 'CASSA RAIFFEISEN DI SCENA SC RAIFFEISENKASSE SCHENNA GEN.',
    ['08236']: 'CASSA RURALE DI SEGNO',
    ['08237']: 'CASSA RURALE DI SEGONZANO',
    ['08238']: "CASSA RAIFFEISEN VAL GARDENA SOCIETA' COOPERATIVA",
    ['08239']: 'CASSA RAIFFEISEN DI SENALES SCRLRAIFFEISENKASSE SCHNALS G.M.B.H.',
    ['08240']: 'CASSA RURALE DI SEREGNANO',
    ['08243']: 'CASSA RURALE DI SFRUZ',
    ['08244']: 'CASSA RAIFFEISEN SILANDRO SCRL RAIFFEISENKASSE SCHLANDERS GMBH',
    ['08246']: 'CASSA RURALE DI SOVER',
    ['08247']: 'CASSA RURALE DI SPERA',
    ['08248']: 'CASSA RURALE VAL RENDENA',
    ['08249']: 'CASSA RAIFFEISEN CAMPO DI TRENS SOC.COOP.-RAIFFEISENKASSE FREIE',
    ['08251']: 'CASSA RURALE DI STREMBO',
    ['08255']: 'CASSA RAIFFEISEN OLTRADIGE SCRL RAIFFEISENKASSE UBERETSCH GMBH',
    ['08258']: 'CREDITO COOPERATIVO CENTRO CALABRIA SOC.COOP',
    ['08260']: 'CASSA RURALE ED ARTIGIANA VAL TAGLIAMENTO',
    ['08263']: "CASSA RURALE D'ANAUNIA BANCA DI CREDITO COOPERATIVO-TAIO-SCPARL.",
    ['08264']: 'CASSA RURALE DI TASSULLO E NANNO',
    ['08266']: 'CASSA RURALE DI TENNA',
    ['08268']: 'CASSA RURALE DI TERLAGO',
    ['08269']: "CASSA RAIFFEISEN ETSCHTAL SOCIETA' COOPERATIVA",
    ['08270']: 'CASSA RURALE DI TERRAGNOLO',
    ['08273']: 'CASSA RAIFFEISEN DI TESIMO SCRL',
    ['08275']: 'CASSA RURALE DI TIARNO',
    ['08278']: 'CASSA RURALE DI TIROLO - RAIFFEISENKASSE TIROL',
    ['08279']: 'CASSA RURALE VALLI DI PRIMIERO E VANOI B.C.C.',
    ['08280']: 'CASSA RURALE DI TRES',
    ['08282']: 'CASSA RURALE VAL DI NON - ROTALIANA E GIOVO - B.C.C. SOC.COOP.',
    ['08285']: 'CASSA RAIFFEISEN TURES - AURINA S.COOP.',
    ['08292']: 'CASSA RURALE DI VALFLORIANA',
    ['08295']: 'CASSA RAIFFEISEN DI VANDOIES SOC. COOP.',
    ['08298']: 'CASSA RURALE DI VEZZANO',
    ['08300']: 'CASSA RURALE DI VIGO-CORTESANO',
    ['08302']: 'CASSA RAIFFEISEN DI VILLABASSA SC - RAIFFEISENKASSE NIEDERDORF GMBH',
    ['08304']: 'CASSA DI TRENTO, LAVIS, MEZZOCORONA, VALLE DI CEMBRA E ALTA VALLAGARINA B.C.C.-S',
    ['08305']: 'CASSA RURALE ALTA VALLAGARINA E LIZZANA BANCA DI CREDITO COOPERATIVO - SC',
    ['08307']: 'CASSA RURALE DELLA VALLE ISARCO - RAIFFEISENKASSE EISACKTAL',
    ['08309']: 'BASSANO BANCA - CREDITO COOPERATIVO',
    ['08311']: 'BENACO BANCA CREDITO COOPERATIVO COSTERMANO S.C. A R.L.',
    ['08313']: 'CASSA RURALE ED ARTIGIANA DI SALGAREDA (TREVISO) - SALGAREDA (TREVISO)',
    ['08315']: 'VALPOLICELLA BENACO BANCA CREDITO COOPERATIVO (VERONA) SOC. COOP',
    ['08316']: 'CASSA RURALE PINETANA FORNACE E SEREGNANO B.C.C. S.C.P.A.R.L.',
    ['08317']: "CASSA RURALE ED ARTIGIANA DELL'AGRO MARSALESE",
    ['08319']: 'CASSA RURALE ED ARTIGIANA BEATO TOMMASO DI CORI',
    ['08322']: 'BANCA VERONESE - CREDITO COOPERATIVO DI CONCAMARISE S.C.R.L.',
    ['08324']: 'BANCA CENTROPADANA - CREDITO COOPERATIVO SCRL',
    ['08325']: 'BANCO FIORENTINO-MUGELLO IMPRUNETA SIGNA-CREDITO COOPERATIVO',
    ['08327']: 'BANCA DI CREDITO COOPERATIVO DI ROMA SOC.COOP. A R.L.',
    ['08329']: "BCC BRIANZA E LAGHI SOCIETA' COOPERATIVA",
    ['08330']: 'BANCA DI CREDITO COOPERATIVO DELLA BASSA FRIULANA SCRL',
    ['08331']: "BANCA DI CREDITO COOPERATIVO DELL'ALTO RENO S.C.",
    ['08332']: 'BANCA PICENA TRUENTINA - CREDITO COOPERATIVO SOC. COOPERATIVA',
    ['08338']: 'BANCA DI CREDITO COOPERATIVO DI ALBEROBELLO',
    ['08340']: 'CASSA PADANA BANCA DI CREDITO COOPERATIVO S.C.R.L.',
    ['08341']: 'BANCA DI CREDITO COOPERATIVO DI ALTOFONTE E CACCAMO S.C.',
    ['08342']: 'BANCA DI CREDITO COOPERATIVO DI AQUARA SCRL',
    ['08344']: 'BANCA DI CREDITO COOPERATIVO DI ANAGNI',
    ['08345']: 'BANCA DI ANGHIARI E STIA CREDITO COOPERATIVO S.C.R.L.',
    ['08351']: 'BANCASCIANO CREDITO COOPERATIVO SCRL',
    ['08354']: 'BANCA DI CREDITO COOPERATIVO DI AVETRANA (TA) SCRL',
    ['08356']: 'BANCA DI CREDITO COOPERATIVO PORDENONESE E MONSILE S.C.',
    ['08358']: "BANCA DI PESCIA E CASCINA CREDITO COOPERATIVO - SOCIETA' COOPERATIVA S.C.",
    ['08362']: 'BANCA DI CREDITO COOPERATIVO DI ARBOREA',
    ['08363']: 'CASSA RURALE ED ARTIGIANA ARDIZZONE',
    ['08365']: "BANCA DI CREDITO COOPERATIVO DELL'ALTO TIRRENO DELLA CALABRIA (CS) SCRL",
    ['08370']: "C.R.A. S.GIOV.BATTISTA DI BALDUINA DI S.URBANO FRAZ.CA'MOROSINI(PADOVA)",
    ['08374']: "BANCA DI CREDITO COOPERATIVO DI BARLASSINA-SOCIETA' COOPERATIVA",
    ['08375']: 'BANCA DI CREDITO COOPERATIVO DI BASILIANO SCRL',
    ['08378']: 'BCC CAMPANIA CENTRO-CASSA RURALE ED ARTIGIANA SOC. COOP.',
    ['08379']: 'BANCA CREDITO COOPERATIVO DI BEDIZZOLE -TURANO VALVESTINO SCRL',
    ['08381']: 'BANCA DI CREDIT0 COOPERATIVO DI BELLEGRA S.C.R.L.',
    ['08382']: 'BENE BANCA CREDITO COOPERATIVO DI BENE VAGIENNA (CUNEO) - S.C.',
    ['08384']: 'CASSA RURALE ED ARTIGIANA DI BETTONA',
    ['08386']: 'CASSA RURALE ED ARTIGIANA DI BINASCO - CREDITO COOPERATIVO SCRL',
    ['08393']: 'CASSA RURALE ED ARTIGIANA DI BORGO SAN GIACOMO (BRESCIA) CREDITO COOP.VO',
    ['08396']: 'BANCA DI CREDITO COOPERATIVO DELLA VALTROMPIA S.C.R.L.',
    ['08397']: 'C.R.A. DI BOVES - BANCA DI CREDITO COOPERATIVO (CN) SCRL',
    ['08398']: 'CASSA RURALE ED ARTIGIANA DI BOZZOLO',
    ['08399']: "BANCA DELLE TERRE VENETE SOCIETA' COOPERATIVA",
    ['08404']: 'BANCA DI CREDITO COOPERATIVO DI BUSTO GAROLFO E BUGUGGIATE SCRL',
    ['08406']: 'BANCA DI CREDITO COOPERATIVO DI BARBARANO ROMANO (VT) SCRL',
    ['08407']: 'BANCA DI CREDITO COOPERATIVO DEL VENEZIANO SCRL',
    ['08409']: 'BANCA DI CREDITO COOPERATIVO DI BUONABITACOLO',
    ['08410']: 'CASSA RURALE ED ARTIGIANA DI CALAMONACI',
    ['08414']: 'BANCA MOLISANA DI CREDITO COOPERATIVO - S.C.R.L.',
    ['08416']: 'BANCA DI VERONA CREDITO COOPERATIVO CADIDAVID SOC. COOP. P.A.',
    ['08420']: 'CASSA RURALE ED ARTIGIANA DI CALUSO (TORINO)',
    ['08422']: 'BANCA DI CREDITO COOPERATIVO DI VERGATO (BO) SCRL',
    ['08425']: 'BANCA CAMBIANO 1884 SPA',
    ['08428']: 'BANCA DI CREDITO COOPERATIVO DI CAMPIGLIA DEI BERICI (VI) SCRL',
    ['08429']: 'BANCA PADOVANA CREDITO COOPERATIVO S.C',
    ['08430']: "CASSA RURALE ED ARTIGIANA DI CANTU' BANCA DI CREDITO COOPERATIVO SOC. COOP.",
    ['08431']: 'BANCA DI CREDITO COOPERATIVO DI CAPACCIO PAESTUM E SERINO S.C.',
    ['08434']: 'BANCA DI CREDITO COOPERATIVO ABRUZZESE - CAPPELLE SUL TAVO SCRL',
    ['08436']: 'BANCA DI CAPRANICA CREDITO COOPERATIVO SCPA',
    ['08437']: 'BANCA DI CREDITO COOPERATIVO DELBASSO SEBINO S.C.R.L.',
    ['08439']: 'BANCA DI CARAGLIO, DEL CUNEESE E DELLA RIVIERA DEI FIORI C.C. SCRL',
    ['08440']: 'BANCA DI CREDITO COOPERATIVO DI CARATE BRIANZA SCRI',
    ['08441']: 'CREDITO COOPERATIVO DI CARAVAGGIO ADDA E CREMASCO-CASSA RURALE S.C.',
    ['08442']: 'CASSA RURALE ED ARTIGIANA DI CARCERI (PADOVA)',
    ['08445']: "BANCA DI CREDITO COOPERATIVO DI TERRA D'OTRANTO S.C.R.L.",
    ['08450']: "BANCA ALPI MARITTIME CREDITO COOPERATIVO CARRU' SCPA",
    ['08452']: 'BANCA DI CREDITO COOPERATIVO DI VENEZIA, PADOVA E ROVIGO - BANCA ANNIA S.C.',
    ['08453']: "BANCA DI CREDITO COOPERATIVO DI MILANO - SOCIETA' COOPERATIVA",
    ['08454']: "CREDITO PADANO BANCA DI CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08455']: 'CASSA RURALE ED ARTIGIANA DI CASALMORO (MANTOVA)',
    ['08456']: 'BANCA DEI SIBILLINI CREDITO COOPERATIVO DI CASAVECCHIA SOC.COOP.',
    ['08457']: 'BANCA DI CREDITO COOPERATIVO DI CASCIA DI REGGELLO S.C.A R.L.',
    ['08458']: 'BANCA DI CREDITO COOPERATIVO DI CASCINA',
    ['08460']: 'BANCA DI CREDITO COOPERATIVO DI CASSANO DELLE MURGE E TOLVE S.C.',
    ['08461']: 'CASTAGNETO BANCA 1910 - CREDITO COOPERATIVO - S.C.',
    ['08462']: 'BANCA DI CREDITO COOPERATIVO DELLA ROMAGNA OCCIDENTALE S.C.R.L.',
    ['08463']: 'CASSA RURALE ED ARTIGIANA DI CASTELFERRETTI (FALCONARA MARITTIMA - ANCONA)',
    ['08466']: "BANCA DI CREDITO COOPERATIVO DI CASTEL GOFFREDO SOCIETA' COOPERATIVA",
    ['08469']: 'CASSA RURALE ED ARTIGIANA DI CASTELLANA GROTTE - CRED. COOP.SCRL',
    ['08472']: "BCC FELSINEA - BCC DAL 1902 - SOCIETA' COOPERATIVA",
    ['08473']: 'BANCA DI CREDITO COOP. DI CASTIGLIONE MESSER RAIMONDO E PIANELLA',
    ['08474']: "BANCA DEL PICENO CREDITO COOPERATIVO SOCIETA' COOPERATIVA",
    ['08481']: 'CEREABANCA 1897 - CREDITO COOPERATIVO SOC. COOP. PER AZIONI A RESPO. LIMITATA',
    ['08487']: 'BANCA DI CREDITO COOPERATIVO DI CHERASCO SCRL',
    ['08489']: 'BANCA VALDICHIANA CREDITO COOPERATIVO DI CHIUSI E MONTEPULCIANO',
    ['08491']: 'BANCO MARCHIGIANO CREDITO COOPERATIVO',
    ['08492']: 'BANCA DI CREDITO COOPERATIVO DI CITTANOVA - SOC.COOP. A RESP. ILL.',
    ['08497']: 'CASSA RURALE ED ARTIGIANA DI COLLELUNGO',
    ['08499']: 'BANCA DI CREDITO COOPERATIVO OROBICA DI BARIANO E COLOGNO AL SERIO (BG)',
    ['08500']: 'CASSA RURALE ED ARTIGIANA DI CONCADIRAME DI ROVIGO (ROVIGO)',
    ['08503']: 'BANCA DI CREDITO COOPERATIVO DI CONVERSANO SCRL',
    ['08508']: 'BANCA DI CREDITO COOPERATIVO DI CORINALDO SCRL',
    ['08509']: 'BANCA CENTRO EMILIA - CREDITO COOPERATIVO S.C.',
    ['08510']: 'CASSA RURALE ED ARTIGIANA DI CORTE PALASIO',
    ['08511']: "CORTINABANCA - CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08514']: "BANCA DI CREDITO COOPERATIVO DELL'OGLIO E DEL SERIO S.C.",
    ['08515']: "BANCA DELLA VALSASSINA CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08516']: 'CASSA RURALE ED ARTIGIANA DI CRESPIATICA',
    ['08519']: 'BANCA DI CREDITO COOPERATIVO DI FANO SCRL',
    ['08530']: "BANCA D'ALBA CREDITO COOPERATIVO SC",
    ['08532']: "BANCA DI CREDITO COOPERATIVO DI DOBERDO' E SAVOGNA S.C.P.A. A R.L.",
    ['08534']: 'CASSA RURALE ED ARTIGIANA DI DUGENTA (BENEVENTO)',
    ['08536']: 'CASSA RURALE ED ARTIGIANA DI ENEMONZO',
    ['08537']: 'CREDITO COOPERATIVO C.R.A. DI ERCHIE (BR)',
    ['08540']: 'BANCA DI SAN MARINO S.P.A',
    ['08542']: 'CREDITO COOPERATIVO RAVENNATE FORLIVESE E IMOLESE SOC. COOP.',
    ['08544']: 'CASSA RURALE ED ARTIGIANA DI FALCONARA MARITTIMA (ANCONA)',
    ['08549']: 'BANCA DI FILOTTRANO - CREDITO COOPERATIVO DI FILOTTRANO E DI CAMERANO SC',
    ['08550']: 'BANCA DI CREDITO COOPERATIVO DI FIUGGI S.C.R.L.',
    ['08551']: 'BANCA DI CREDITO COOPERATIVO DI FIUMICELLO ED AIELLO DEL FRIULI -UD-',
    ['08553']: 'BANCA DI CREDITO COOPERATIVO DI FLUMERI SOC. COOP.',
    ['08554']: 'BANCA DI CREDITO COOPERATIVO DI GAUDIANO DI LAVELLO',
    ['08556']: "BANCA DI FORLI' - CREDITO COOPERATIVO SCRL",
    ['08558']: 'CASSA RURALE ED ARTIGIANA DI FORNI DI SOPRA',
    ['08559']: 'CASSA RURALE ED ARTIGIANA DI FORNI DI SOTTO (PROVINCIA DI UDINE)',
    ['08561']: 'BANCA DI SALERNO CREDITO COOPERATIVO S.C.R.L.',
    ['08562']: 'BANCA DI PISA E FORNACETTE CREDITO COOPERATIVO SCPA',
    ['08565']: 'BANCA DI CREDITO COOPERATIVO DI BUCCINO',
    ['08572']: 'BANCA DI CREDITO COOPERATIVO DI GAMBATESA',
    ['08574']: 'BANCA DI CREDITO COOPERATIVO DI GATTEO SCRL',
    ['08575']: 'BCC AGROBRESCIANO SOC. COOP.',
    ['08578']: 'BANCA DI CREDITO COOPERATIVO DI GRADARA SCRL',
    ['08579']: 'CASSA RURALE ED ARTIGIANA DI GRAFFIGNANA (PROVINCIA DI MILANO)',
    ['08586']: 'BANCA DI CREDITO COOPERATIVO DI GHISALBA (BERGAMO)',
    ['08587']: 'B.C.C. VALDOSTANA COOPERATIVE DE CREDIT VALDOTAINE S.C.R.L.',
    ['08590']: 'BANCA DEL VENETO CENTRALE - CREDITO COOPERATIVO - SOC. COOP.',
    ['08591']: 'BANCA DI CREDITO COOPERATIVO DI IMPRUNETA-BANCO FIORENTINO - S.C.',
    ['08595']: 'LA BCC DEL CROTONESE CREDITO COOPERATIVO S.C.',
    ['08597']: 'BCC BASILICATA - CREDITO COOPERATIVO DI LAURENZANA E COMUNI LUCANI',
    ['08601']: "BANCA DI CREDITO COOPERATIVO VALLE DEL TORTO - SOCIETA' COOPERATIVA",
    ['08603']: 'BANCA DI CREDITO COOPERATIVO DI LEVERANO (LE) SCRL',
    ['08606']: 'BANCA DI CREDITO COOPERATIVO DI CANOSA -LOCONIA SCRL',
    ['08607']: 'BANCA DI CREDITO COOPERATIVO DI LOCOROTONDO - CASSA RURALE ED ARTIGIANA',
    ['08610']: 'BANCA DEI COLLI EUGANEI CREDITO COOPERATIVO LOZZO ATESTINO S.C.',
    ['08614']: 'CASSA RURALE ED ARTIGIANA DI LUNGAVILLA',
    ['08616']: 'BANCA ADIGE PO CREDITO COOPERATIVO LUSIA SOC. COOP..',
    ['08618']: 'BANCA DI CREDITO COOPERATIVO DI LEZZENO SCRL',
    ['08619']: 'BANCA CREDITO COOPERATIVO DI LESMO',
    ['08621']: 'CASSA RURALE ED ARTIGIANA DI SIANO (SALERNO)',
    ['08622']: 'CREDITO COOPERATIVO - CASSA RURALE ED ARTIGIANA DEL FRIULI VENEZIA GIULIA SC',
    ['08623']: 'BANCO COOPERATIVO EMILIANO-CREDITO COOPERATIVO-SOC.COOP.',
    ['08629']: 'CASSA RURALE ED ARTIGIANA DI MANDATORICCIO',
    ['08630']: 'BANCA DI MANTIGNANA - CREDITO COOPERATIVO UMBRO S.C. A R.L.',
    ['08631']: "BANCA 360 CREDITO COOPERATIVO FVG - SOCIETA' COOPERATIVA",
    ['08636']: "BANCA DELLA MAREMMA - CREDITO COOPERATIVO GROSSETO - SOCIETA' COOPERATIVA",
    ['08637']: "PRIMACASSA - CREDITO COOPERATIV O FVG - SOCIETA' COOPERATIVA",
    ['08639']: 'BANCA DI CREDITO COOPERATIVO DI MASIANO (PISTOIA)',
    ['08644']: 'CASSA RURALE ED ARTIGIANA DI MEZZANO E VILLA FILETTO',
    ['08661']: 'BANCA DI CREDITO COOPERATIVO IRPINA S.C. A R.L.',
    ['08669']: 'BVR BANCA - BANCHE VENETE RIUNITE CREDITO COOPERATIVO S.C.',
    ['08670']: 'BANCA DI CREDITO COOPERATIVO DI MONTEPULCIANO S.C.R.L.',
    ['08672']: 'BANCA DI CREDITO COOPERATIVO DI MONTERENZIO SOC. COOP.',
    ['08673']: 'CHIANTIBANCA - CREDITO COOPERATIVO - S.C.',
    ['08676']: 'BANCA DI CREDITO COOPERATIVO COLLI MORENICI DEL GARDA SOC. COOP.',
    ['08679']: 'BANCA DI CREDITO COOPERATIVO DI MOZZANICA (BG) SCRL',
    ['08682']: 'BANCA DI CREDITO COOPERATIVO ALTO CASERTANO E BASSO FRUSINATE',
    ['08688']: 'BANCA DI CREDITO COOPERATIVO DI MARINA DI GINOSA SCARL',
    ['08689']: 'BANCA DI CREDITO COOPERATIVO DI MARCON - VENEZIA SC',
    ['08692']: 'BANCA DI CREDITO COOPERATIVO DI BRESCIA S.C.',
    ['08693']: 'BANCA DI CREDITO COOPERATIVO DI NETTUNO S.C.R.L.',
    ['08700']: 'BANCA DI CREDITO COOPERATIVO DEL METAURO S.C.R.L.',
    ['08704']: "BANCA DI CREDITO COOPERATIVO DI OSTRA E MORRO D'ALBA S.C.R.L.",
    ['08705']: 'BANCA DI CREDITO COOPERATIVO DI OSTRA VETERE SCRL',
    ['08706']: 'BANCA DI CREDITO COOPERATIVO DI OSTUNI S.C.RL.',
    ['08708']: 'BANCA DI CREDITO COOPERATIVO DI OPPIDO LUCANO E RIPACANDIDA SCRL',
    ['08712']: 'BANCA DI CREDITO COOPERATIVO SEN. PIETRO GRAMMATICO DI PACECO',
    ['08713']: 'BANCA DI CREDITO COOPERATIVO DI PACHINO (SIRACUSA) SCRI',
    ['08715']: "BANCA DI UDINE CREDITO COOPERATIVO SOCIETA' COOP.VA",
    ['08716']: "BANCA CENTRO LAZIO CREDITO COOPERATIVO SOCIETA' COOPERATIVA",
    ['08717']: 'CREDITO COOPERATIVO - CASSA RURALE ED ARTIGIANA DI PALIANO SCRL',
    ['08719']: 'CASSA RURALE ED ARTIGIANA DI PALMA DI MONTECHIARO',
    ['08720']: 'BANCA DI CREDITO COOPERATIVO DI PEDEMONTE S.C.A R.L.',
    ['08726']: "BANCA VERSILIA LUNIGIANA E GARFAGNANA - CREDITO COOPERATIVO SOCIETA' COOPERATIVA",
    ['08728']: "BANCA PATAVINA CREDITO COOPERATIVO DI SANT'ELENA E PIOVE DI SACCO SC",
    ['08730']: 'BANCA DI CREDITO COOPERATIVO DI PITIGLIANO',
    ['08731']: "BANCA DI CREDITO COOPERATIVO DI PERGOLA E CORINALDO SOCIETA' COOPERATIVA",
    ['08732']: 'BANCA DI CREDITO COOPERATIVO VICENTINO - POJANA MAGGIORE (VI)',
    ['08735']: 'BANCA DEL TERRITORIO LOMBARDO CREDITO COOPERATIVO SOC. COOP.',
    ['08736']: 'BANCA DI CREDITO COOPERATIVO DI PONTASSIEVE SOC. COOP.',
    ['08738']: "CASSA RURALE ED ARTIGIANA DELL'AGRO PONTINO - B.C.C.",
    ['08743']: 'BANCA DI CREDITO COOPERATIVO DEL VELINO - POSTA (RI) SCRL',
    ['08744']: 'BANCA DI CREDITO COOPERATIVO DI DOVERA E POSTINO (CR) SOC. COOP.',
    ['08745']: 'BANCA DI CREDITO COOPERATIVO VALLE SERIANA SCRL (BG)',
    ['08747']: 'BANCA DI CREDITO COOPERATIVO DI PRATOLA PELIGNA',
    ['08749']: 'CENTROMARCA BANCA CREDITO COOPERATIVO DI TREVISO E VENEZIA',
    ['08753']: "BANCA DI CREDITO COOPERATIVO DI PIANFEI E ROCCA DE' BALDI S.C.R.L.",
    ['08755']: 'CASSA RURALE ED ARTIGIANA DI PAMPARATO',
    ['08759']: 'CASSA RURALE ED ARTIGIANA DI RIPACANDIDA',
    ['08762']: 'CASSA RURALE ED ARTIGIANA DI SANTA MARIA DEL CEDRO (COSENZA)',
    ['08764']: 'CASSA RURALE ED ARTIGIANA DI RASA',
    ['08765']: 'B.C.C. DI RECANATI E COLMURANO - RECANATI (MC) SCRL',
    ['08769']: 'BANCA DI RIPATRANSONE E DEL FERMANO - CREDITO COOPERATIVO SC',
    ['08770']: 'CASSA RURALE ED ARTIGIANA DI RIVAROLO MANTOVANO (MANTOVA)',
    ['08771']: "CREDITO COOPERTAIVO DELL'ADDA E DEL CREMASCO - CASSA RURALE",
    ['08772']: 'CASSA RURALE ED ARTIGIANA DI ROANA - CREDITO COOPERATIVO SCRL',
    ['08777']: 'BANCA DI CREDITO COOPERATIVO DEL TUSCOLO - ROCCA PRIORA (RM) SCRL',
    ['08778']: 'BANCA DI CREDITO COOPERATIVO DI RONCIGLIONE E BARBARANO ROMANO S.C.',
    ['08782']: 'CASSA RURALE ED ARTIGIANA DI RUSSI E S.PANCRAZIO - RUSSI (RAVENNA)',
    ['08784']: 'BANCA MONTE PRUNO CREDITO COOPERATIVO DI FISCIANO, ROSCIGNO E LAURINO SC',
    ['08787']: 'BCC DELLA PROVINCIA ROMANA SOC. COOPERATIVA',
    ['08792']: 'BANCA DI CREDITO COOPERATIVO DI SALA DI CESENATICO (FO) SOC. COOP.VA',
    ['08794']: 'BANCA DI CREDITO COOPERATIVO LODI S.C.',
    ['08796']: 'BANCA DI CREDITO COOPERATIVO DI SAMBUCA DI SICILIA',
    ['08800']: 'BANCA DI CREDITO COOPERATIVO DI SAN BIAGIO PLATANI SCRI',
    ['08805']: 'FRIULOVEST BANCA-CREDITO COOPERATIVO-SOCIETA COOPERATIVA',
    ['08807']: "BCC DI VERONA E VICENZA CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08810']: 'BANCA DI CREDITO COOPERATIVO DI SAN GIOVANNI ROTONDO',
    ['08811']: 'BANCA CREDITO COOPERATIVO DI S. GIOVANNI VALDARNO',
    ['08812']: 'BANCA DI CREDITO COOPERATIVO DI FORMELLO',
    ['08817']: 'BANCA DI CREDITO COOPERATIVO DI SAN MARZANO DI SAN GIUSEPPE SCRL',
    ['08824']: 'BANCA DI CREDITO COOPERATIVO DI SERINO (AVELLINO) S.C.',
    ['08826']: 'BANCA DI PESARO CREDITO COOPERATIVO SOC. COOP. A R.L.',
    ['08828']: 'CASSA RURALE ED ARTIGIANA DI S.PIETRO IN TRENTO (RAVENNA)',
    ['08829']: 'BANCA DI CREDITO COOPERATIVO DI S. PIETRO IN VINCIO (PISTOIA)',
    ['08833']: 'BANCA TERRITORI DEL MONVISO S.C.',
    ['08835']: 'CASSA RUR.ED ART.DI S.MARIA DELLA CROCE-S.MARIA DELLA CROCE DI CREMA (CREMONA)',
    ['08839']: 'BANCA SUASA - CREDITO COOPERATIVO SOC. COOP.',
    ['08843']: "BANCA DI CREDITO COOPERATIVO DI SANT'ELENA (PD) SCRL",
    ['08844']: 'BANCA DI CREDITO COOPERATIVO DI SANTERAMO IN COLLE SCRL',
    ['08850']: 'BANCA DI CREDITO COOPERATIVO DI SARSINA (FO) SCRI',
    ['08851']: 'TERRE ETRUSCHE DI VALDICHIANA E DI MAREMMA - CRED.COOP. - S.C.',
    ['08852']: 'ROMAGNABANCA CREDITO COOPERATIVOS.C.',
    ['08855']: 'BANCA DI CREDITO COOPERATIVO DI SCAFATI E CETARA S.C.R.L.',
    ['08860']: 'CASSA RURALE ED ARTIGIANA DI SELCI (RIETI)',
    ['08864']: 'CASSA RURALE ED ARTIGIANA DI SERRE ( SALERNO )',
    ['08865']: 'BANCA DI CREDITO COOPERATIVO DI SESTO SAN GIOVANNI',
    ['08866']: 'BANCA DI CREDITO COOPERATIVO DI SIGNA SCRL',
    ['08867']: 'BANCA DI CREDITO COOPERATIVO DELLA SILA PICCOLA',
    ['08869']: 'BANCA DI CREDITO COOPERATIVO DI BERGAMO E VALLI S.C.',
    ['08871']: 'BANCA DI CREDITO COOPERATIVO DI SPELLO E DEL VELINO SOC. COOP.',
    ['08873']: 'BCC APPULO LUCANA',
    ['08877']: 'BANCA DI CREDITO COOPERATIVO VENEZIA GIULIA',
    ['08883']: 'BANCA DI BOLOGNA',
    ['08885']: 'BANCA CRAS - CR.COOP. TOSCANO - SIENA',
    ['08887']: 'CREDITO COOPERATIVO DI SAN CALOGERO E MAIERATO - BCC DEL VIBONESE - SC',
    ['08894']: 'BANCA DI CARNIA E GEMONESE CREDITO COOPERATIVO S.C.R.L.',
    ['08899']: 'CASSA RURALE - BANCA DI CREDITO COOPERATIVO DI TREVIGLIO SOC.COP',
    ['08901']: 'BANCA DI CREDITO COOPERATIVO DI TRIUGGIO E DELLA VALLE DEL LAMBRO',
    ['08903']: 'BANCA DI CREDITO COOPERATIVO DI TURRIACO SOC. COOP.',
    ['08904']: "BANCA PREALPI SANBIAGIO CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08907']: 'BANCA DI CREDITO COOPERATIVO DI SCANDALE SCRL',
    ['08908']: 'CASSA RURALE ED ARTIGIANA DI TRUCCAZZANO (MILANO)',
    ['08910']: 'CASSA RURALE ED ARTIGIANA DI VESTENANOVA (VERONA)',
    ['08913']: 'BANCA DI CREDITO COOPERATIVO DELLA VALLE DEL FITALIA - LONGI SCRL',
    ['08916']: 'BANCA DI ANCONA - CREDITO COOPERATIVO S.C.R.L.',
    ['08917']: "CREDITO TREVIGIANO - BANCA DI CREDITO COOPERATIVO - SOCIETA' COOPERATIVA",
    ['08919']: 'BANCA DI CREDITO COOPERATIVO DI VEROLAVECCHIA S.C.R.L.',
    ['08920']: 'CASSA RURALE ED ARTIGIANA DI VESIO',
    ['08922']: 'BANCA ALTA TOSCANA CREDITO COOPERATIVO - SC',
    ['08926']: 'CASSA RURALE ED ARTIGIANA DI VILLANOVA DEL GHEBBO',
    ['08928']: 'ZKB CREDITO COOPERATIVO DI TRIESTE E GORIZIA S.C.',
    ['08931']: 'BANCA LAZIO NORD CREDITO COOPERATIVO SCPA',
    ['08940']: 'BANCA DI CREDITO COOPERATIVO BERGAMASCA E OROBICA S.C.',
    ['08941']: 'BANCA DI CREDITO COOPERATIVO SAN MARCO - CALATABIANO CATANIA',
    ['08943']: 'CASSA RURALE ED ARTIGIANA SAN PAOLO (TRAPANI)',
    ['08944']: 'CASSA RURALE ED ARTIGIANA FEDE E LAVORO-MAZARA DEL VALLO',
    ['08946']: 'BANCA DON RIZZO - CREDITO COOPERATIVO DELLA SICILIA OCCIDENTALE',
    ['08947']: 'BANCA DI CREDITO COOPERATIVO DON STELLA DI RESUTTANO',
    ['08951']: "BANCA DI CREDITO COOPERATIVO DEI COLLI ALBANI - SOCIETA' COOPERATIVA",
    ['08952']: 'B.C.C. G.TONIOLO E SAN MICHELEDI SAN CATALDO (CALTANISSETTA)S.C.',
    ['08954']: 'BANCA DI CREDITO COOPERATIVO LA RISCOSSA DI REGALBUTO',
    ['08958']: 'BANCA DI CREDITO COOPERATIVO MUTUO SOCCORSO DI GANGI',
    ['08959']: 'CASSA RURALE ED ARTIGIANA PALICORUM DI PALAGONIA',
    ['08964']: 'CASSA RURALE ED ARTIGIANA S. BARNABA DI MARINO',
    ['08965']: 'BANCA S.BIAGIO DEL VENETO ORIENTALE DI CESAROLO E FOSSALTA DI P. BCC SCRL',
    ['08968']: 'BANCA DI CREDITO COOPERATIVO DI ABRUZZI E MOLISE - SOC. COOP.',
    ['08969']: "BANCA S. FRANCESCO - CREDITO COOPERATIVO - CANICATTI' SCRL",
    ['08970']: 'BANCA DI RIMINI - CREDITO COOPERATIVO SCRL',
    ['08973']: 'C.R.A. SAN GIUSEPPE CREDITO COOPERATIVO CAMERANO SCRL (AN)',
    ['08975']: 'BANCA DI CREDITO COOPERATIVO SAN GIUSEPPE DI MUSSOMELI',
    ['08976']: 'BANCA DI CREDITO COOPERATIVO DELLE MADONIE - SOC. COOP.',
    ['08979']: 'BANCA DI CREDITO COOPERATIVO S. MICHELE DI CALTANISSETTA E PIETRAPERZIA',
    ['08981']: 'CASSA RURALE ED ARTIGIANA SAN PIO DI CODEVILLA (PAVIA)',
    ['08982']: "BANCA ADRIA COLLI EUGANEI - CREDITO COOPERATIVO SOCIETA' COOPERATIVA",
    ['08983']: 'CASSA RURALE ED ARTIGIANA S. ANNA DI SCIARA',
    ['08985']: 'SICILBANCA - CREDITO COOPERATIVOITALIANO',
    ['08986']: 'ROVIGOBANCA CREDITO COOPERATIVO',
    ['08987']: "BANCA DI CREDITO COOPERATIVO TERRA DI LAVORO-S.VINCENZO DE' PAOLI SCPA",
    ['08988']: 'BANCA DI CREDITO COOPERATIVO DEGLI ULIVI - TERRA DI BARI SCRL',
    ['08990']: 'BANCA DI CREDITO COOPERATIVO SANTO STEFANO MARTELLAGO SCRL',
    ['08995']: 'RIVIERABANCA CREDITO COOPERATIVO DI RIMINI E GRADARA - SOC.COOP.',
    ['08997']: 'BCC DI S.MARCO DEI CAVOTI E DEL SANNIO CALVI SOCIETA COOPERATIVA',
    ['08998']: 'CASSA RAIFFEISEN DELLA VAL PASSIRIA SOC. COOP. A R.L.',
    ['09500']: 'MOONEY S.P.A. (PER MONETICA)',
    ['09501']: 'MONEYNET (PER MONETICA)',
    ['09502']: 'MOONEY S.P.A. (PER MONETICA)',
    ['09504']: 'IPAGOO LLP (PER MONETICA)',
    ['09505']: 'PAYMOVE S.P.A. (PER MONETICA)',
    ['09506']: 'A-TONO PAYMENT INSTITUTE S.P.A. (PER MONETICA)',
    ['09509']: 'POSTEPAY S.P.A. (PER MONETICA)',
    ['09512']: 'SIAPAY S.R.L. (PER MONETICA)',
    ['09515']: 'BCC PAY S.P.A. (X MONETICA)',
    ['09518']: 'LIS PAY S.P.A. (PER MONETICA)',
    ['10001']: 'ISTITUTO DI CREDITO AGRARIO SPA - FEDERAGRARIO SPA',
    ['10002']: 'IST. FEDERALE CASSE RISP. DELLE VENEZIE SEZIONE DI CREDITO AGRARIO',
    ['10003']: "ISTITUTO FEDERALE DI CREDITO AGRARIO PER L'EMILIA ROMAGNA",
    ['10010']: 'ISTITUTO CREDITO FONDIARIO DELLE VENEZIESEZIONE DI CREDITO AGRARIO DI MIGLIOR.',
    ['10011']: 'MEDIOCREDITO TRENTINO-ALTO ADIGE SEZ.AUT. PER IL CRED. AGRARIO DI MIGL.',
    ['10012']: 'CENTROBANCA SEZIONE DI CREDITO AGRARIO',
    ['10015']: 'BANCO DI SARDEGNA SEZIONE SPECIALE DI CREDITO AGRARIO',
    ['10302']: 'BANCA NAZIONALE DEL LAVORO SEZIONE AUTONOMA DI CREDITO FONDIARIO',
    ['10307']: 'CREDITO FONDIARIO DELLA CASSA DI RISPARMIO DI GORIZIA',
    ['10309']: 'MONTE PASCHI FONDIARIO E OPERE PUBBLICHESPA',
    ['10312']: 'CREDITO FONDIARIO S.P.A.',
    ['10314']: 'CREDITO FONDIARIO DELLA CASSA DI RISPARMIO DI ROMA',
    ['10315']: 'ISTITUTO DI CREDITO FONDIARIO UMBRO MARCHIGIANO',
    ['10317']: 'CREDITO FONDIARIO DELLA CASSA RISPARMIO DI CALABRIA E DI LUCANIA',
    ['10318']: 'BANCO DI SARDEGNA SEZIONE DI CREDTIO FONDIARIO',
    ['10321']: "ISTITUTO DI CREDITO FONDIARIO DEL PIEMONTE E DELLA VALLE D'AOSTA",
    ['10327']: 'BANCA NAZIONALE DEL LAVORO - SEZ. CRED. CINEMATOGRAFICO E TEATRALE SPA - ROMA',
    ['10616']: 'BANCO DI SICILIA SEZIONE DI CREDITO INDUSTRIALE',
    ['10624']: "BANCA NAZIONALE DEL LAVORO-SEZ.AUT. FIN.OO.PP. E IMP. PUBBLICA UTILITA'SPA",
    ['10626']: 'ISTITUTO DI CREDITO FONDIARIO DELLA TOSCANA-SEZIONE OPERE PUBBLICHE',
    ['10627']: 'CASSA DI RISPARMIO DI GORIZIA SEZIONE OPERE PUBBLICHE',
    ['10629']: 'IST.CRED.FOND. DELLE MARCHE,UMBRIA, ABRUZZI,MOLISE-SEZ.OO.PP.',
    ['10630']: 'ISTITUTO PER IL CREDITO SPORTIVO',
    ['10631']: 'MEDIOBANCA BANCA DI CREDITO FINANZIARIO S.P.A.',
    ['10632']: 'EFIBANCA S.P.A.',
    ['10633']: 'CENTROBANCA - BANCA CENTRALE DI CREDITO POPOLARE',
    ['10634']: "IST.CRED.FOND. DELLE VENEZIE SEZ.AUT. FINAN.OO.PP.-IMP.PUBBL.UTILITA'",
    ['10636']: '2S BANCA S.P.A.',
    ['10637']: 'MEDIOCREDITO ITALIANO SPA',
    ['10638']: 'MEDIOCREDITO TRENTINO ALTO ADIGE SPA',
    ['10640']: 'BCC FINANCING S.P.A.',
    ['10642']: 'MEDIOCREDITO EMILIA ROMAGNA',
    ['10643']: 'MPS CAPITAL SERVICES BANCA PER LE IMPRESE S.P.A.',
    ['10645']: 'MEDIOCREDITO REGIONALE DELLE MARCHE',
    ['10647']: "ISTITUTO PER LO SVILUPPO ECONOMICO DELL'ITALIA MERIDIONALE",
    ['10650']: "ISTITUTO NAZIONALE DI CREDITO PER IL LAVORO ITALIANO ALL'ESTERO",
    ['10651']: "MONTE PASCHI SIENA-SEZ.AUT FINAN. OO.PP E IMP.PUBBLICA UTILITA'",
    ['10652']: "IST.BANC. S.PAOLO TORINO SEZ.AUT. FINAN.OO.PP. E IMP.PUBBL.UTILITA'",
    ['10653']: "CASSA DI RISPARMIO DI BOLOGNA-SEZ.AUT. FINANZ.OO.PP. E IMP. PUBBL. UTILITA'",
    ['10656']: "CASSA DI RISPARMIO DI ROMA-SEZ.AUT. FINANZ.OO.PP. E IMP. PUBBLICA UTILITA'",
    ['10657']: "BANCO DI SARDEGNA-SEZ.AUT.FINANZ.OO.PP. E IMP. DI PUBLLICA UTILITA'",
    ['10660']: "IST.CRED.FOND.REG. TRENTINO ALTO ADIGE SEZ.AUT.FIN.OO.PP.-IMP.PUBBL.UTILITA'",
    ['10680']: 'MCC S.P.A.',
    ['10681']: 'ARTIGIANCASSA S.P.A.',
    ['10687']: 'MEDIOCREDITO ABRUZZESE E MOLISANO SPA',
    ['12600']: 'FONDO INTERBANCARIO DI TUTELA DEI DEPOSITI',
    ['12928']: "SOCIETA' PER I SERVIZI BANCARI SPA - MILANO",
    ['12930']: 'MONTE TITOLI SPA - MILANO',
    ['12935']: 'NEXI PAYMENTS SPA',
    ['12940']: 'BCC SISTEMI INFORMATICI S.C.P.A.',
    ['18103']: 'FINOM PAYMENTS B.V.',
    ['18147']: 'ITAS PAY S.P.A.',
    ['18164']: 'XOLDY S.P.A.',
    ['18175']: 'ZPAY S.R.L.',
    ['18301']: 'BKN301 S.P.A.',
    ['19275']: 'COMPASS BANCA S.P.A.',
    ['19423']: 'SCANIA FINANCE ITALY S.P.A.',
    ['21096']: 'COMMERZBANK AG',
    ['21112']: 'BARCLAYS BANK LONDON',
    ['21175']: 'RABOBANK INTERNATIONAL',
    ['21211']: 'BANCA DEL GOTTARDO',
    ['22001']: 'J.P. MORGAN SECURITIES LTD',
    ['22178']: 'SALOMON BROTHERS INTERNATIONAL LTD - MILAN BRANCH',
    ['32447']: 'ITALFONDIARIO SPA',
    ['32532']: 'MOONEY S.P.A.',
    ['32698']: 'LIS ISTITUTO DI PAGAMENTO SPA',
    ['32875']: 'NEXI PAYMENTS S.P.A.',
    ['33500']: 'SISAL GROUP S.P.A.',
    ['33604']: 'SIAPAY S.R.L.',
    ['36000']: 'LIS PAY S.P.A.',
    ['36001']: 'MOBILMAT IMEL SPA (ENTE CREDITIZIO)',
    ['36003']: "FLOWE S.P.A. - SOCIETA' BENEFIT",
    ['36014']: 'C-CARD S.P.A.',
    ['36017']: 'MOONEY S.P.A.',
    ['36018']: 'CABEL IP S.P.A.',
    ['36019']: 'AMERICAN EXPRESS PAYMENTS EUROPE S.L.',
    ['36024']: 'MOONEY S.P.A.',
    ['36033']: 'MONEYNET S.P.A.',
    ['36039']: 'CCN SERVIZI DI PAGAMENTO S.P.A.',
    ['36040']: 'INTERCARD FINANCE AD',
    ['36041']: "SOCIETA' SERVIZI DI PAGAMENTO - SOCIETA' PER AZIONI",
    ['36042']: 'ICONTO SRL',
    ['36044']: 'BMCE EUROSERVICE S.A.',
    ['36047']: 'SOGEFIN S.P.A.',
    ['36049']: 'IPAGOO LLP',
    ['36050']: 'PAYMOVE S.P.A.',
    ['36051']: '2PAY ISTITUTO DI MONETICA ELETTRONICA S.R.L.',
    ['36063']: 'BUFFETTI FINANCE S.P.A.',
    ['36064']: 'A-TONO PAYMENT INSTITUTE S.P.A.',
    ['36068']: 'TELEPASS PAY SPA (IMEL)',
    ['36071']: 'AFONE PAIEMENT',
    ['36072']: 'MACCORP FINANCIAL SERVICES S.R.L.',
    ['36080']: 'ADMIRAL PAY IP S.R.L.',
    ['36081']: 'POSTEPAY S.P.A.',
    ['36085']: 'MOONEY S.P.A.',
    ['36087']: 'VIVA PAYMENT SERVICES S.A.',
    ['36092']: 'OLINDA SAS',
    ['36330']: 'UNIFIEDPOST PAYMENTS SA',
    ['36593']: 'TREEZOR SAS',
    ['36772']: 'HYPE S.P.A.',
    ['36928']: 'TPPAY S.R.L.',
    ['36935']: 'AXERVE S.P.A.',
    ['36960']: 'UNIPOLPAY S.P.A.',
    ['36964']: 'BCC PAY S.P.A.',
    ['90000']: 'CASSA DI COMPENSAZIONE E GARANZIA SPA',
};
/**
 * Sorgenti in cui il movimento e' il dato autorevole della banca, non una
 * copia caricata a mano. Specchio strutturale dei membri corrispondenti
 * dell'enum Prisma `ImportSource`: `@repo/utils` non dipende da
 * `@repo/database`, ma i valori restano assegnabili in entrambe le direzioni.
 *
 * Distinzione usata per decidere cosa l'utente puo' eliminare: la riga della
 * banca torna al sync successivo, quella importata a mano no.
 */
export const SYNCED_IMPORT_SOURCES = ['ACUBE', 'FABRICK'];
export const isSyncedImportSource = (importSource) => SYNCED_IMPORT_SOURCES.includes(importSource);
//# sourceMappingURL=bank.js.map